export default {
  pt_BR: {
    message: {
      batch_number_is_required: 'Número do lote é obrigatório',
      device_is_required: 'Dispositivo é obrigatório',
      barn_is_required: 'Galpão é obrigatório',
      initial_date_is_required: 'Data inicial é obrigatório',
      initial_hour_is_required: 'Hora inicial é obrigatório',
      final_date_is_required: 'Data final é obrigatório',
      final_hour_is_required: 'Hora final é obrigatório',
      state_is_required: 'Estado é obrigatório',
      quantity_housed_is_required: 'Quantidade alojada é obrigatório',
      quantity_housed_must_be_an_integer: 'Quantidade alojada deve ser um número inteiro',
      quantity_housed_must_be_greater_than_or_equal_to_zero: 'Quantidade alojada deve ser maior ou igual a zero',
      quantity_housed_must_be_less_than_or_equal_to_1000000: 'Quantidade alojada deve ser menor ou igual a 1000000',
      loading: 'Carregando...',
      curtain: 'Cortina',
      water_temperature: 'Temperatura da aǵua',
      external_temperature: 'Temperatura externa',
      external_humidity: 'Umidade externa',
      external_temp: 'Temp. externa',
      external_humid: 'Umid. externa',
      water_temp: 'Temp. água',
      curtain_opening_percentage: 'Porcentagem de abertura da cortina',
      line: 'Linha',
      bar: 'Barra',
      area: 'Área',
      opened: 'Aberto',
      closed: 'Fechado',
      batch_number: 'Número do lote',
      finished: 'Finalizado',
      in_progress: 'Em andamento',
      running: 'Rodando',
      from: 'do',
      confirming_action_cannot_undone: 'Ao confirmar essa ação não poderá ser revertida.',
      status: 'Estado',
      side: 'Lado',
      wind: 'Vento',
      weight_percentage_heavy: 'Pesado',
      weight_percentage_light: 'Leve',
      weight_percentage_very_heavy: 'Super pesado',
      weight_percentage_very_light: 'Super leve',
      weight_distribution: 'Distribuição de peso',
      weight_percentage: 'Percentual de pesagem',
      daily_weight_gain: 'Ganho de peso diário',
      weight_gain: 'Ganho de peso',
      average_weight: 'Peso médio',
      maximum_weight: 'Peso máximo',
      minimum_weight: 'Peso mínimo',
      maximum_and_minium_weights: 'Pesos máximos e mínimos',
      maximum_and_minimum_temperatures: 'Temperaturas máximas e mínimas',
      maximum_and_minimum_humidities: 'Umidades máximas e mínimas',
      maximum_and_minimum_co2: 'CO2 máximas e mínimas',
      chart: 'Gráfico',
      charts: 'Gráficos',
      correlations: 'Correlações',
      environment: 'Ambiente',
      performance: 'Desempenho',
      email_must_be_valid: 'Email deve ser válido',
      internet_connection: 'Conexão com Internet',
      latitude: 'Latitude',
      longitude: 'Longitude',
      responsible_contact: 'Contato do responsável',
      responsible_phone: 'Telefone do responsável',
      responsible_email: 'Email do responsável',
      owner: 'Proprietário',
      birth_day: 'Data de nascimento',
      change: 'Alterar',
      account: 'Conta',
      entries: 'Cadastros',
      width: 'Largura',
      height: 'Altura',
      length: 'Comprimento',
      date: 'Data',
      initial_date: 'Data inicial',
      final_date: 'Data final',
      initial_hour: 'Hora inicial',
      final_hour: 'Hora final',
      reading: 'Leitura',
      readings: 'Leituras',
      statistic: 'Estátistica',
      statistics: 'Estátisticas',
      inobram_platform: 'Plataforma Inobram',
      platform: 'Plataforma',
      enter: 'Entrar',
      forgot_my_password: 'Esqueci minha senha',
      access_demo: 'Acessar demonstração',
      recover_password: 'Recuperar senha',
      recover_password_in_app_instructions: 'Para recuperar sua senha, utilize a opção "Esqueci minha senha" no aplicativo Inobram. Informe o e-mail ou telefone cadastrado, receba o código de verificação e defina uma nova senha.',
      add: 'Adicionar',
      add_device: 'Adicionar dispositivo',
      list_devices: 'Listar dispositivos',
      device: 'Dispositivo',
      devices: 'Dispositivos',
      equipment: 'Equipamento',
      equipments: 'Equipamentos',
      type: 'Tipo',
      description: 'Descrição',
      indicates_that_the_field_is_required: '*Indica que o campo é obrigatório',
      create_your_account: 'Crie sua conta',
      create: 'Criar',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      save: 'Salvar',
      save_for_all: 'Salvar para todos',
      name: 'Nome',
      password: 'Senha',
      confirm_the_password: 'Confirme a senha',
      password_must_be_at_least_6_characters: 'A senha deve ter ao menos 6 caracteres',
      the_password_is_invalid_or_the_user_does_not_have_a_password: 'A senha é inválida ou o usuário não possui uma senha.',
      the_email_address_is_badly_formatted: 'O endereço de email está mal formatado.',
      there_is_no_user_record_corresponding_to_this_identifier_the_user_may_have_been_deleted: 'Não há registro de usuário correspondente a esse identificador. O usuário pode ter sido excluído.',
      profile: 'Perfil',
      add_nucleus: 'Adicionar núcleo',
      list_nuclei: 'Listar núcleos',
      nuclei: 'Núcleos',
      nucleus: 'Núcleo',
      add_property: 'Adicionar propriedade',
      edit_property: 'Editar propriedade',
      property: 'Propriedade',
      properties: 'Propriedades',
      users: 'Usuários',
      add_user: 'Adicionar usuário',
      updated_at: 'Atualizado em',
      reports_and_settings: 'Relatórios e configurações',
      establishing_remote_access_session: 'Estabelecendo sessão de acesso remoto',
      remote_access_failed: 'Não foi possível estabelecer a sessão de acesso remoto. Verifique se o dispositivo está online.',
      only_owner_can_remote_access: 'Apenas o proprietário do dispositivo pode acessar remotamente o controlador',
      water_consumption_today: 'Consumo de água hoje',
      water_consumption: 'Consumo de água',
      daily_water_consumption: 'Consumo de água diário',
      feed_level: 'Nível de ração',
      yes: 'Sim',
      no: 'Não',
      alerts: 'Alertas',
      settings: 'Configurações',
      not_connected: 'Não conectado',
      inobram_account: 'Conta da Inobram',
      navigation_menu: 'Menu de navegação',
      exit: 'Sair',
      added_at: 'Adicionado em',
      added_by: 'Adicionado por',
      edit: 'Editar',
      delete: 'Excluir',
      delete_mortality_from_date: 'Excluir mortalidade do dia',
      close: 'Fechar',
      all: 'Todos',
      rows_per_page: 'Linhas por página',
      no_data: 'Nenhum dado disponível',
      items_to_show: 'Itens para mostrar',
      chage_view_mode: 'Altera o modo de visualização',
      setting_alarm_value: 'Configura os valores para alarmes',
      invalid_mac: 'MAC inválido',
      invalid_mac_pattern: 'Padrão do MAC inválido',
      to_view: 'Visualizar',
      minimum: 'Mínimo',
      maximum: 'Máximo',
      alarm_level: 'Nível do alarme',
      next: 'Próximo',
      previous: 'Anterior',
      countries: 'Países',
      states: 'Estados',
      cities: 'Cidades',
      sexes: 'Sexos',
      country: 'País',
      state: 'Estado',
      city: 'Cidade',
      sex: 'Sexo',
      device_models: 'Modelos de dispositivo',
      device_types: 'Tipos de dispositivo',
      mortalities: 'Mortalidades',
      device_model: 'Modelo de dispositivo',
      device_type: 'Tipo de dispositivo',
      mortality: 'Mortalidade',
      daily_mortality: 'Mortalidade diária',
      culling_deaths: 'Mortes por refugo',
      culling: 'Refugo',
      natural_deaths: 'Mortes naturais',
      natural: 'Natural',
      quantity: 'Quantidade',
      quantity_housed: 'Quantidade alojada',
      batch: 'Lote',
      batches: 'Lotes',
      wall: 'Parede',
      walls: 'Paredes',
      floor: 'Piso',
      floors: 'Pisos',
      roof: 'Cobertura',
      roofs: 'Coberturas',
      inner_curtain: 'Cortina interna',
      inner_curtains: 'Cortinas internas',
      outer_curtain: 'Cortina externa',
      outer_curtains: 'Cortinas externas',
      lining: 'Forro',
      linings: 'Forros',
      evaporative_plate: 'Placa evaporativa',
      evaporative_plates: 'Placas evaporativas',
      lighting_system: 'Sistema de iluminação',
      lighting_systems: 'Sistemas de iluminações',
      internet_access_type: 'Tipo de acesso a Internet',
      internet_access_types: 'Tipos de acesso a Internet',
      barn: 'Galpão',
      barns: 'Galpões',
      filter_by_property: 'Filtrar por propriedade',
      filter_by_nucleus: 'Filtrar por núcleo',
      filter_by_country: 'Filtrar por país',
      filter_by_state: 'Filtrar por estado',
      filter_by_city: 'Filtrar por cidade',
      location: 'Localização',
      structure: 'Estrutura',
      filters: 'Filtros',
      view_mode: 'Modo de visualização',
      card_view: 'Cartões',
      list_view: 'Lista',
      active_filters: '{count} filtro ativo | {count} filtros ativos',
      clear_filters: 'Limpar filtros',
      no_barns_found: 'Nenhum galpão encontrado.',
      barn_type: 'Tipo de galpão',
      barn_types: 'Tipos de galpões',
      voltage_type: 'Tipo de tensão',
      voltage_types: 'Tipos de tensões',
      air_inlet: 'Entrada de ar',
      air_inlets: 'Entradas de ar',
      silo_type: 'Tipo de silo',
      silo_types: 'Tipos de silo',
      water_box: 'Caixa de água',
      water_boxes: 'Caixas de água',
      watchdog_system: 'Sistema de watchdog',
      watchdog_systems: 'Sistemas de watchdog',
      batch_state: 'Estado do lote',
      batch_states: 'Estados do lote',
      capacity: 'Capacidade',
      capacity_estimated: 'estimada',
      manufacturer: 'Fabricante',
      manufacturers: 'Fabricantes',
      ok: 'OK',
      copied_to_the_clipboard: 'copiado para a área de transferência.',
      error_copying_text: 'Erro ao copiar texto.'
    },
    notification_history: {
      notifications: 'Notificações',
      unread_count: '{count} não lidas',
      mark_all_as_read: 'Marcar todas como lidas',
      no_notifications: 'Você ainda não tem notificações',
      load_error: 'Não foi possível carregar as notificações',
      see_all: 'Todas as notificações',
      load_more: 'Carregar mais',
      notified_at: 'Notificado às {time}',
      viewed_at: 'Vista em {time}',
      delivery_sent: 'Entregue',
      delivery_failed: 'Falha na entrega',
      delivery_no_device: 'Não enviada: nenhum dispositivo conectado'
    },
    alarm: {
      alarm: 'Alarme',
      alarms: 'Alarmes',
      active_alarms: 'Alarmes Ativos',
      alarms_and_notifications: 'Alarmes e Notificações',
      see_all: 'Ver Todos',
      mute: 'Silenciar',
      mute_all: 'Silenciar todos',
      unmute: 'Reativar som',
      reactivate_all: 'Reativar todos',
      alarm_history: 'Histórico de Alarmes',
      tab_analysis: 'Análise de Alarmes',
      no_active_alarms: 'Não há alarmes ativos no momento',
      no_alarm_history: 'Não há alarmes registrados neste período',
      select_barn_and_batch: 'Selecione um galpão e um lote para visualizar o histórico de alarmes',
      all_barns: 'Todos os Galpões',
      select_batch: 'Selecione um Lote',
      sort_by: 'Ordenar por:',
      sort_date: 'Data',
      sort_name: 'Nome',
      date_time: 'Data/Hora',
      alarms_per_page: 'Alarmes por página',
      current: 'Atual',
      updated_just_now: 'Atualizado agora mesmo',
      updated_seconds_ago: 'Atualizado há {count}s',
      updated_minutes_ago: 'Atualizado há {count} min',
      updated_at: 'Atualizado às {time}',
      overview_last_24h: 'Visão geral · Últimas 24h · Todos os galpões',
      new_alarm_flash: 'Novo alarme!',
      sound_enabled: 'Som ativado',
      sound_disabled: 'Som bloqueado — clique para ativar',
      sound_unavailable: 'Som indisponível neste navegador',
      alarms_silenced: 'Alarmes silenciados',
      filters: 'Filtros',
      axis_date: 'Data',
      axis_age: 'Idade do Lote',
      start_date: 'Data inicial',
      start_time: 'Hora inicial',
      end_date: 'Data final',
      end_time: 'Hora final',
      age_start: 'Idade inicial',
      age_end: 'Idade final',
      info_last_days: 'Mostrando dados dos últimos 7 dias. Selecione um galpão e um lote para análise mais detalhada.',
      info_filtered: 'Mostrando dados do galpão e lote selecionados.',
      clear_all_filters: 'Limpar todos os filtros',
      export: 'Exportar',
      export_csv: 'Exportar CSV',
      export_pdf: 'Exportar PDF',
      report_title: 'Relatório de Alarmes',
      report_generated_at: 'Gerado em',
      report_period: 'Período',
      report_summary: 'Resumo',
      charts: 'Gráficos',
      total_alarms: 'Total de Alarmes',
      alarm_records: 'Registros de alarmes',
      alarm_peak: 'Pico de Alarmes',
      alarms_per_day: 'Alarmes p/dia',
      alarms_label: 'alarmes',
      timeline_title: 'Linha do Tempo de Alarmes',
      distribution_by_barn: 'Distribuição de Alarmes por Galpão',
      distribution_title: 'Distribuição de Alarmes',
      alarm_type: 'Tipo de Alarme',
      quantity: 'Quantidade',
      proportion: 'Proporção',
      total: 'Total',
      page: 'Página',
      heatmap_title: 'Mapa de Calor - Horários Críticos',
      low_quantity: 'Baixa Quantidade',
      high_quantity: 'Alta Quantidade',
      details_title: 'Detalhes de Alarmes',
      details_inobramx_note: 'As colunas de resolução e de valores ambientais desejados só são preenchidas para controladores SMAAI 5 PRO/SMART. Para os demais modelos, esses campos aparecem como “-”.',
      col_resolved_at: 'Resolvido em',
      col_alarm_value: 'Valor do alarme',
      col_temp_desired: 'Temp. Desejada (°C)',
      col_temp_avg: 'Temp. Média (°C)',
      col_humidity_desired: 'Umid. Desejada (%)',
      col_humidity_avg: 'Umid. Média (%)',
      col_pressure_desired: 'Press. Desejada (pa)',
      col_pressure_avg: 'Press. Média (pa)',
      col_co2: 'CO2 (ppm)',
      high_temperature: 'Temperatura alta',
      low_temperature: 'Temperatura baixa',
      high_humidity: 'Umidade alta',
      low_humidity: 'Umidade baixa',
      high_pressure: 'Pressão alta',
      low_pressure: 'Pressão baixa',
      low_battery: 'Bateria baixa',
      low_source: 'Falta de energia',
      no_probe_installed: 'Sem sonda instalada',
      null_temperature: 'Temperatura zerada',
      probe_error: 'Erro em sonda',
      relay_error: 'Erro na placa de rele',
      LEIT_SONDA: 'Erro na leitura de sonda',
      INST_SONDA: 'Erro na instalação de sonda',
      TEMP_ALTA: 'Temperatura baixa',
      TEMP_BAIXA: 'Temperatura baixa',
      UMIDADE_ALTA: 'Umidade alta',
      UMIDADE_BAIXA: 'Umidade baixa',
      PRESSAO_ALTA: 'Pressão alta',
      PRESSAO_BAIXA: 'Pressão baixa',
      BATERIA_BAIXA: 'Bateria baixa',
      FALTA_ENERGIA: 'Falta de energia',
      DESARME_CORT: 'Desarme de cortina',
      ERROR_RELAY: 'Erro na placa de rele',
      ERROR_PROBE_TH2O1: 'Erro na sonda TH2O1',
      ERROR_PROBE_TH2O2: 'Erro na sonda TH2O2',
      ERROR_PROBE_TH2O3: 'Erro na sonda TH2O3',
      ERRO_SONDA_TH2O1: 'Erro na sonda TH2O1',
      ERRO_SONDA_TH2O2: 'Erro na sonda TH2O2',
      ERRO_SONDA_TH2O3: 'Erro na sonda TH2O3',
      ERRO_SONDA_T1: 'Erro na sonda T1',
      ERRO_SONDA_T2: 'Erro na sonda T2',
      ERRO_SONDA_T3: 'Erro na sonda T3',
      ERRO_SONDA_T4: 'Erro na sonda T4',
      ERRO_SONDA_T5: 'Erro na sonda T5',
      ERRO_SONDA_TU1: 'Erro na sonda TU1',
      ERRO_SONDA_TU2: 'Erro na sonda TU2',
      ERRO_SONDA_TU3: 'Erro na sonda TU3',
      ERRO_SONDA_U1: 'Erro na sonda U1',
      ERRO_SONDA_U2: 'Erro na sonda U2',
      ERRO_SONDA_P1: 'Erro na sonda P1',
      ERRO_SONDA_CO21: 'Erro na sonda CO21',
      ERRO_SONDA_H2O1: 'Erro na sonda H2O1',
      high_temp: 'Temperatura alta',
      low_temp: 'Temperatura baixa',
      high_hum: 'Umidade alta',
      low_hum: 'Umidade baixa',
      high_co2: 'CO2 alto',
      fault_energy: 'Falta de energia',
      low_bat: 'Bateria baixa',
      over_voltage: 'Sobretensão',
      ve_error: 'Erro no sensor de vento',
      co2_error: 'Erro na sonda CO2',
      overload: 'Sobrecarga',
      t1_error: 'Erro na sonda T1',
      t2_error: 'Erro na sonda T2',
      t3_error: 'Erro na sonda T3',
      t4_error: 'Erro na sonda T4',
      th2o1_error: 'Erro na sonda TH2O1',
      th2o2_error: 'Erro na sonda TH2O2',
      th2o3_error: 'Erro na sonda TH2O3',
      tu1_error: 'Erro na sonda TU1',
      tu2_error: 'Erro na sonda TU2',
      tu3_error: 'Erro na sonda TU3',
      tu4_error: 'Erro na sonda TU4',
      u1_error: 'Erro na sonda U1',
      u2_error: 'Erro na sonda U2',
      ve1_error: 'Erro na sonda VE1'
    },
    notification: {
      attention: 'Atenção',
      confirm_exclusion: 'Confirma exclusão?',
      deleted_successfully: 'Excluído com sucesso!',
      saved_successfully: 'Salvo com sucesso!',
      there_was_an_error_saving: 'Ocorreu um erro ao salvar',
      there_was_an_error: 'Ocorreu um erro',
      discontinued_add_device_warning: 'Para adicionar dispositivos, utilize o InoBram App'
    },
    card_legend: {
      title: 'Entendendo os indicadores do card',
      intro: 'Cada medidor e barra muda de cor conforme a situação da variável. Veja a lógica de cada um: Use o botão de configurações (engrenagem) para escolher quais métricas aparecem nos cards.',
      button: 'Legenda do card',
      state: {
        ideal: 'Ideal',
        attention: 'Atenção',
        critical: 'Crítico',
        reference: 'Referência',
        no_data: 'Sem dados'
      },
      temperature: {
        title: 'Temperatura',
        desc: 'O anel mostra o quanto a temperatura atual se afasta da temperatura desejada.',
        ideal: 'Até ±1 °C da temperatura desejada.',
        attention: 'Entre ±1 °C e ±2 °C da temperatura desejada.',
        critical: 'Mais de ±2 °C da temperatura desejada.',
        reference: 'Exibido em azul quando não há temperatura desejada configurada.'
      },
      humidity: {
        title: 'Umidade',
        desc: 'O anel é preenchido com a umidade relativa atual, colorido pela distância até o alvo.',
        ideal: 'Até ±5% da umidade desejada.',
        attention: 'Entre ±5% e ±10% da umidade desejada.',
        critical: 'Mais de ±10% da umidade desejada.',
        reference: 'Exibido em azul quando não há umidade desejada configurada.'
      },
      co2: {
        title: 'CO₂',
        desc: 'O anel é preenchido com a concentração de CO₂; a marca vermelha indica o limite elevado.',
        ideal: 'Até 1500 ppm (boa qualidade do ar).',
        attention: 'Entre 1500 e 2500 ppm (qualidade do ar moderada).',
        critical: 'Acima de 2500 ppm (CO₂ elevado).',
        no_data: 'Exibido em cinza quando não há leitura disponível.'
      },
      feels_like: {
        title: 'Sensação térmica',
        desc: 'Temperatura aparente que combina o calor e a umidade percebidos pelas aves. Comparada à temperatura desejada.',
        equation: 'AT = T + 0.33 × e − 4.00\ne = (UR / 100) × 6.105 × exp(17.27 × T / (237.7 + T))',
        where: 'T = temperatura (°C); UR = umidade relativa (%); e = pressão de vapor (hPa). Temperatura aparente de Steadman (ambiente interno, sem vento).',
        ideal: 'Sensação até ±1 °C da temperatura desejada.',
        attention: 'Entre ±1 °C e ±2 °C da temperatura desejada.',
        critical: 'Mais de ±2 °C da temperatura desejada.',
        reference: 'Exibido em azul quando não há temperatura desejada configurada.'
      },
      thi: {
        title: 'THI (índice de temperatura e umidade)',
        desc: 'Indicador de estresse por calor que combina temperatura e umidade em um único número.',
        equation: 'THI = T − (0.31 − 0.0031 × UR) × (T − 14.4)',
        where: 'T = temperatura (°C); UR = umidade relativa (%). Adaptado de NRC (1971) / Marai et al. (2001) para aves.',
        ideal: 'Abaixo de 27 (sem estresse por calor).',
        attention: 'Entre 27 e 29 (alerta de calor).',
        critical: 'Igual ou acima de 29 (estresse por calor).'
      },
      enthalpy: {
        title: 'Entalpia',
        desc: 'Energia total do ar (calor sensível + latente) que a ave precisa dissipar. Quanto maior, mais difícil a troca de calor.',
        equation: 'h = 1.006 × T + W × (2501 + 1.805 × T)\nW = 0.622 × Pv / (Patm − Pv)',
        where: 'W = razão de mistura (kg água / kg ar seco); Pv = pressão de vapor; Patm = 101,325 kPa. A faixa ideal varia com a idade (Rodrigues et al. 2011).',
        reference: 'Valor informativo (azul): a faixa ideal depende da idade do lote.'
      },
      ventilation: {
        title: 'Ventilação',
        desc: 'Sinal combinado de qualidade do ar. CO₂ alto indica pouca renovação de ar; junto com umidade elevada aponta ventilação insuficiente (típico do frio, em ventilação mínima).',
        equation: 'CO₂ > 2500 ppm  ⇒  Ruim\nCO₂ > 1500 ppm  ou  UR alta  ⇒  Moderada',
        where: 'UR alta = 10% acima do alvo (ou acima de 70%, sem alvo). Combina CO₂ e umidade.',
        ideal: 'CO₂ e umidade sob controle (boa ventilação).',
        attention: 'CO₂ moderado ou umidade elevada (ventilação moderada).',
        critical: 'CO₂ alto, muitas vezes com umidade elevada (ventilação ruim).',
        no_data: 'Exibido em cinza quando não há leitura de CO₂.'
      },
      silo: {
        title: 'Silos',
        desc: 'As barras são preenchidas com o nível de ração em relação à capacidade do silo (20.000 kg quando nenhuma capacidade é configurada).',
        ideal: 'Igual ou acima de 30% da capacidade.',
        attention: 'Entre 15% e 30% da capacidade.',
        critical: 'Abaixo de 15% da capacidade.'
      },
      metrics: {
        title: 'Idade, pressão, água e peso',
        desc: 'Valores informativos, sem estados de cor: idade do lote (dias), pressão estática (Pa), água consumida hoje (L) e peso médio das aves (g). Pressão e água podem ser ocultadas nas configurações do card.'
      }
    },
    card_settings: {
      button: 'Configurações do card',
      title: 'Métricas exibidas nos cards',
      intro: 'Escolha quais métricas opcionais aparecem em cada card de dispositivo.',
      reset: 'Restaurar padrão',
      pressure: { title: 'Pressão estática', desc: 'Pressão estática de ventilação (Pa).' },
      water: { title: 'Água', desc: 'Água consumida hoje (L).' },
      feelsLike: { title: 'Sensação térmica', desc: 'Temperatura aparente combinando calor e umidade.' },
      thi: { title: 'THI', desc: 'Índice de temperatura e umidade (estresse por calor).' },
      enthalpy: { title: 'Entalpia', desc: 'Carga térmica total do ar (kJ/kg de ar seco).' },
      ventilation: { title: 'Ventilação', desc: 'Qualidade do ar a partir de CO₂ e umidade.' }
    },
    comfort: {
      feels_like: 'Sensação',
      feels_like_tip: 'Temperatura aparente (sensação térmica): combina calor e umidade.',
      thi: 'THI',
      thi_tip: 'Índice de temperatura e umidade — indicador de estresse por calor.',
      enthalpy: 'Entalpia',
      enthalpy_tip: 'Entalpia do ar (kJ/kg de ar seco) — carga térmica total.',
      ventilation: 'Ventilação',
      ventilation_tip: 'Qualidade da ventilação a partir de CO₂ e umidade.',
      ventilation_good: 'Boa',
      ventilation_moderate: 'Moderada',
      ventilation_poor: 'Ruim',
      ventilation_no_data: '--'
    },
    environment: {
      age: 'Idade',
      days: 'dias',
      temperature: 'Temperatura',
      humidity: 'Umidade',
      pressure: 'Pressão',
      co2: 'CO2',
      air_quality_good: 'Qualidade do ar boa',
      air_quality_moderate: 'Qualidade do ar moderada',
      air_quality_high: 'CO2 elevado',
      water: 'Água',
      weight: 'Peso',
      desired_weight: 'Peso desejado',
      silo: 'Silo',
      silos: 'Silos',
      desired_temperature: 'Temperatura desejada',
      desired_temperature_prefix: 'Temp. desejada',
      maximum_temperature: 'Temperatura máxima',
      minimum_temperature: 'Temperatura mínima',
      desired_humidity: 'Umidade desejada',
      desired_humidity_prefix: 'Umid. desejada',
      maximum_humidity: 'Umidade máxima',
      minimum_humidity: 'Umidade mínima',
      desired_pressure: 'Pressão desejada',
      desired_pressure_prefix: 'Pres. desejada',
      maximum_co2: 'CO2 máxima',
      minimum_co2: 'CO2 mínima',
      average_temperature: 'Temperatura média',
      average_temperature_internal: 'Temp. média interna',
      average_temperature_external: 'Temp. média externa',
      average_humidity: 'Umidade média',
      average_humidity_internal: 'Umid. média interna',
      average_humidity_external: 'Umid. média externa',
      average_co2: 'CO2 média',
      temperature_range: 'Faixa de temperatura',
      temperature_range_internal: 'Faixa temp. interna',
      humidity_range: 'Faixa de umidade',
      humidity_range_internal: 'Faixa umid. interna',
      co2_range: 'Faixa de CO2',
      weight_range: 'Faixa de peso',
      range_to: 'a',
      show_external: 'Mostrar externa',
      external_temperature_range: 'Faixa temp. externa',
      external_humidity_range: 'Faixa umid. externa',
      delta_temperature: 'Delta temperatura (int - ext)',
      delta_humidity: 'Delta umidade (int - ext)',
      delta_temperature_desired: 'Δ desejada - média',
      delta_humidity_desired: 'Δ desejada - média',
      weight_gain_vs_temp: 'Ganho de peso vs desvio de temperatura',
      temp_deviation: 'Desvio de temperatura (°C)',
      mortality_vs_environment: 'Mortalidade vs temperatura/umidade',
      temp_deviation_short: 'Δ Temperatura',
      humidity_deviation_short: 'Δ Umidade',
      water_vs_temp: 'Consumo de água vs temperatura',
      water_liters: 'Água (l)',
      avg_temp: 'Temp. média (°C)',
      uniformity_vs_co2: 'Uniformidade de peso vs CO2',
      weight_cv: 'CV peso (%)',
      avg_co2: 'CO2 média (ppm)',
      water_per_bird_vs_gain: 'Água por ave vs ganho de peso',
      water_per_bird: 'Água/ave (ml)',
      weight_gain_vs_humidity: 'Ganho de peso vs desvio de umidade',
      humidity_deviation: 'Desvio de umidade (%)',
      quantity_housed: 'Quantidade alojada'
    },
    prefix: {
      ag: 'Id',
      dt: 'Td',
      at: 'T',
      dh: 'Ud',
      ah: 'U',
      wt: 'Ag (L)',
      dw: 'Pd (g)',
      aw: 'Pm (g)',
      dp: 'Pd (Pa)',
      ap: 'P (Pa)',
      s1: 'S1',
      s2: 'S2',
      st: 'Estado',
      t_max: 'T max',
      t_min: 'T min',
      h_max: 'U max',
      h_min: 'U min',
      p_max: 'P max',
      p_min: 'P min',
      co2_max: 'co2 max',
      co2_min: 'co2 min',
      h2o_acc: 'h2o acumulado'
    },
    table: {
      of: 'de',
      all: 'Todas',
      rows_per_page_text: 'Linhas por página',
      quantity_per_page_text: 'Quantidade por página'
    },
    banner_premium_plan: {
      platform: 'Plataforma',
      info: '\nPara maiores detalhes sobre a disponibilidade dessa funcionalidade contate nosso time através do contato:\n',
      get_in_touch: 'Entrar em\n  contato'
    },
    insights: {
      title: 'Insights do lote',
      no_insights: 'Sem observações para este lote',
      heat_stress: '{count} dia(s) com estresse térmico detectado',
      heat_stress_detail: 'Temperatura média acima do setpoint em mais de 2°C nas idades: {ages}',
      co2_breach: '{count} dia(s) com CO₂ acima de 2500 ppm',
      co2_breach_detail: 'Concentração elevada pode causar estresse respiratório. Idades: {ages}',
      humidity_out_of_range: '{count} dia(s) com umidade fora da faixa ideal',
      humidity_detail: 'Desvio médio acima de 10% do setpoint nas idades: {ages}',
      uniformity_alert: '{count} dia(s) com uniformidade de peso baixa (CV > 10%)',
      uniformity_detail: 'Pior dia: idade {age} com CV de {cv}%',
      growth_decline: 'Queda acentuada no ganho de peso',
      growth_decline_detail: 'Pico de {peakGain}g/dia na idade {peakAge}, caiu para {currentGain}g/dia',
      peak_growth: 'Pico de ganho diário: {gain}g na idade {age}',
      water_gain_spike: '{count} dia(s) com relação água/ganho acima do normal',
      water_gain_spike_detail: 'Consumo elevado relativo ao ganho nas idades: {ages}',
      mortality_spike: '{count} dia(s) com mortalidade acima da média',
      mortality_spike_detail: 'Picos nas idades: {ages} (média do lote: {avg}/dia)',
      total_mortality: 'Mortalidade acumulada de {pct}% do lote',
      info_title: 'Como funcionam as análises',
      info_intro: 'A plataforma analisa automaticamente os dados do lote e gera observações quando identifica condições que podem impactar o desempenho. Abaixo estão todas as análises que o sistema é capaz de realizar:',
      info_heat_stress_title: 'Estresse térmico',
      info_heat_stress_desc: 'Compara a temperatura média interna (média entre máxima e mínima do dia) com o setpoint de temperatura configurado. Sinaliza quando a média excede o setpoint em mais de 2°C. Torna-se crítico quando 3 ou mais dias apresentam essa condição.',
      info_co2_title: 'CO₂ elevado',
      info_co2_desc: 'Monitora a concentração máxima diária de CO₂. Sinaliza quando o pico ultrapassa 2500 ppm, nível que pode causar estresse respiratório nas aves. Torna-se crítico com 3 ou mais dias acima do limite.',
      info_humidity_title: 'Umidade fora da faixa',
      info_humidity_desc: 'Calcula o desvio da umidade média interna em relação ao setpoint configurado. Sinaliza quando o desvio absoluto excede 10 pontos percentuais. Torna-se aviso com 5 ou mais dias fora da faixa.',
      info_uniformity_title: 'Uniformidade de peso',
      info_uniformity_desc: 'Calcula o coeficiente de variação (CV% = desvio padrão / peso médio × 100) a partir dos dados de pesagem diários, desconsiderando a primeira semana de vida (a variação de peso no alojamento é natural). Sinaliza quando o CV excede 10%, indicando que o lote pode estar desuniforme.',
      info_growth_title: 'Declínio no ganho de peso',
      info_growth_desc: 'Identifica o pico de ganho diário de peso e sinaliza se o ganho atual caiu para menos de 60% desse pico dentro dos últimos 5 dias, o que pode indicar problemas de saúde ou nutricionais. Também informa o dia do pico de ganho como referência.',
      info_peak_growth_title: 'Pico de ganho diário',
      info_peak_growth_desc: 'Informa a idade e o valor do maior ganho diário de peso registrado no lote, servindo como referência para avaliar a curva de crescimento.',
      info_water_gain_title: 'Relação água/ganho',
      info_water_gain_desc: 'Calcula a relação entre consumo de água e ganho de peso diário e a compara com a própria tendência recente do lote (média dos dias anteriores), desconsiderando a primeira semana de vida. Sinaliza quando a relação sobe de forma abrupta (mais de 1,35× a tendência recente) por pelo menos 2 dias, o que pode indicar problemas de saúde ou conforto térmico.',
      info_mortality_title: 'Mortalidade',
      info_mortality_desc: 'Monitora a mortalidade diária, desconsiderando a primeira semana de vida (a mortalidade de alojamento é naturalmente mais alta). Sinaliza quando um dia registra mais que o dobro da média do período seguinte (crítico acima do triplo). Também acompanha a mortalidade acumulada: aviso acima de 3% e crítico acima de 5% do total alojado.',
      info_severity_title: 'Níveis de severidade:',
      info_severity_critical: 'Crítico — requer atenção imediata',
      info_severity_warning: 'Aviso — merece acompanhamento',
      info_severity_info: 'Informativo — dado de referência'
    },
    chart_dialog: {
      mortality_dialog: 'Esse gráfico apresenta a mortalidade para cada idade do lote, diferenciando mortalidades por refugo das mortalidades ocorridas por causas naturais.',
      water_consumption_dialog: 'Esse gráfico apresenta o consumo de água para cada idade do lote. ',
      weight_distribution_dialog: 'Esse gráfico apresenta em níveis percentuais a distribuição de pesagem em cada sonda para cada idade do lote.',
      weight_gain_dialog: 'Esse gráfico apresenta o ganho de peso cada idade.',
      average_weight_dialog: 'Esse gráfico apresenta o peso médio para cada idade, bem como a maior e menor pesagem registrada para a idade.',
      co2_dialog: 'Esse gráfico apresenta o CO2 médio para cada idade, bem como a maior e menor média de CO2 registrado para a idade.',
      humidity_dialog: 'Esse gráfico apresenta a umidade média para cada idade, bem como a maior e menor média de umidade registrada para a idade.',
      temperature_dialog: 'Esse gráfico apresenta a temperatura média para cada idade, bem como a maior e menor média de temperatura registrada para a idade.',
      mortality_dialog_title: 'Gráfico de mortalidade',
      water_consumption_dialog_title: 'Gráfico de consumo diário de água',
      weight_distribution_dialog_title: 'Gráfico de distribuição de pesagem',
      weight_gain_dialog_title: 'Gráfico de ganho de peso diário',
      average_weight_dialog_title: 'Gráfico de peso médio',
      co2_dialog_title: 'Gráfico de CO2',
      humidity_dialog_title: 'Gráfico de umidade',
      temperature_dialog_title: 'Gráfico de temperatura',
      weight_gain_vs_temp_dialog: 'Correlaciona o ganho de peso diário com o desvio da temperatura média em relação ao setpoint. Permite identificar como o estresse térmico afeta o desempenho.',
      weight_gain_vs_temp_dialog_title: 'Ganho de peso vs desvio de temperatura',
      mortality_vs_env_dialog: 'Sobrepõe a mortalidade diária com os desvios de temperatura e umidade em relação aos setpoints. Ajuda a identificar causas ambientais de mortalidade.',
      mortality_vs_env_dialog_title: 'Mortalidade vs ambiente',
      water_vs_temp_dialog: 'Correlaciona o consumo de água com a temperatura média interna. Aves consomem mais água em temperaturas elevadas — desvios do padrão podem indicar problemas.',
      water_vs_temp_dialog_title: 'Consumo de água vs temperatura',
      uniformity_vs_co2_dialog: 'Correlaciona o coeficiente de variação do peso (uniformidade) com o CO2 médio. Níveis elevados de CO2 podem reduzir a uniformidade do lote.',
      uniformity_vs_co2_dialog_title: 'Uniformidade vs CO2',
      water_per_bird_vs_gain_dialog: 'Mostra a relação entre consumo de água por ave e ganho de peso. Uma proporção crescente pode indicar estresse, doença ou problemas de alimentação.',
      water_per_bird_vs_gain_dialog_title: 'Água por ave vs ganho de peso',
      weight_gain_vs_humidity_dialog: 'Correlaciona o ganho de peso com o desvio de umidade em relação ao setpoint. Umidade alta reduz a capacidade de termorregulação das aves.',
      weight_gain_vs_humidity_dialog_title: 'Ganho de peso vs desvio de umidade'
    },
    aei: {
      dashboard: 'Painel',
      filter_by_complex: 'Filtrar por complexo',
      filter_by_site: 'Filtrar por site',
      no_filter_match: 'Nenhum galpão corresponde aos filtros.',
      house_count: '1 galpão | {count} galpões',
      machine_count: '1 equipamento | {count} equipamentos',
      kpi: {
        feed: 'Ração',
        temperature: 'Temperatura',
        humidity: 'Umidade',
        co2: 'CO₂',
        nh3: 'NH₃',
        water: 'Água',
        outside_temp: 'Temp. externa',
        static_pressure: 'Pressão',
        cooler_temp: 'Câmara fria',
        ph: 'pH',
        water_temp: 'Temp. da água',
        flow_efficiency: 'Eficiência de fluxo',
        run_time_efficiency: 'Tempo produtivo',
        total_cases: 'Caixas',
        stops: 'Paradas',
        concentration: 'Sanitizante',
        recirculation_temp: 'Temp. recirculação',
        water_flow: 'Vazão de água',
        ph_target: 'pH alvo',
        run_time: 'Tempo de operação',
        sanitizer_flow: 'Vazão de sanitizante',
        undiluted_concentration: 'Sanitizante puro'
      },
      feed_bins: 'Silos de ração',
      houses: 'Galpões',
      processing: 'Sala de processamento',
      title: 'AEI Integra',
      total_feed: 'Ração total',
      bin: 'Silo',
      no_houses: 'Nenhum galpão recebeu dados ainda.',
      no_readings: 'Sem leituras disponíveis.',
      no_processing: 'Nenhum equipamento de processamento recebeu dados ainda.',
      stale: 'Desatualizado',
      stale_hint: 'A última leitura tem mais de 12 horas.',
      last_reading: 'Última leitura',
      measured_at: 'Medido em',
      updated_just_now: 'Atualizado agora mesmo',
      updated_minutes: 'Atualizado há {count} min',
      updated_hours: 'Atualizado há 1 hora | Atualizado há {count} horas',
      updated_days: 'Atualizado há 1 dia | Atualizado há {count} dias',
      gateway_seen_just_now: 'Último envio agora mesmo',
      gateway_seen_minutes: 'Último envio há {count} min',
      gateway_seen_hours: 'Último envio há 1 hora | Último envio há {count} horas',
      gateway_seen_days: 'Último envio há 1 dia | Último envio há {count} dias',
      gateway_never_seen: 'Nenhum envio recebido ainda',
      loading: 'Carregando...',
      records: {
        feed_bin: 'Silos de ração',
        environment: 'Ambiente',
        water_use: 'Consumo de água',
        feed_use: 'Consumo de ração',
        feed_delivered: 'Entregas de ração',
        alarm: 'Alarmes',
        chicken: 'Lote',
        flock: 'Alojamento',
        egg: 'Contagem de ovos',
        tier_egg: 'Coleta de ovos',
        fan: 'Ventiladores',
        heater: 'Aquecedores',
        cool_cell: 'Painéis evaporativos e bombas',
        vfd_fan: 'Velocidade de ventilação',
        light: 'Iluminação',
        power: 'Saídas',
        sensor: 'Sensores de temperatura',
        group: 'Zonas de temperatura',
        maintenance: 'Manutenção'
      },
      back_to_houses: 'Galpões',
      metric: 'Variável',
      value: 'Valor',
      plan_inactive: 'O plano AEI deste complexo não está ativo. Os dados não estão mais sendo recebidos; o histórico continua disponível.',
      devices_without_plan: 'Nenhum dispositivo sem plano ativo. | 1 dispositivo sem plano ativo não recebe mais dados. | {count} dispositivos sem plano ativo não recebem mais dados.'
    },
    bird_weight: {
      title: 'Pesagens',
      subtitle: 'Pesagem de aves',
      all_barns: 'Todos os aviários',
      select_barn: 'Aviário',
      select_batch: 'Selecione o lote',
      tab_history: 'Histórico de pesagem',
      tab_analysis: 'Análise e projeção de peso',
      back_to_overview: 'Pesagens',
      no_barn_selected: 'Selecione um aviário para ver o histórico de pesagem e a análise de peso.',
      no_weighings: 'Nenhuma pesagem disponível.',
      no_batch_selected: 'Selecione um lote para ver as pesagens.',
      loading: 'Carregando...',
      age: 'Idade',
      average_weight: 'Peso médio',
      weighing_gain: 'Ganho de peso',
      weight_count: 'Quantidade de pesagem',
      max: 'Peso máximo',
      min: 'Peso mínimo',
      standard_deviation: 'Desvio padrão',
      ideal_weight: 'Peso ideal',
      uniformity: 'Uniformidade',
      current_weight: 'Peso atual: {0}g',
      overview_current_age: 'Idade atual',
      overview_last_weighing: 'Última pesagem',
      overview_uniformity: 'Uniformidade',
      overview_deviation: 'Desvio vs. curva',
      overview_no_data: 'Sem pesagens',
      overview_no_data_hint: 'Este aviário ainda não possui pesagens registradas.',
      overview_open_batch: 'Nenhum lote em aberto',
      overview_status_running: 'Em andamento',
      overview_status_closed: 'Encerrado',
      overview_view_history: 'Histórico e Projeção',
      overview_weighing_age: 'Idade {0}',
      overview_days: 'dias',
      overview_flock: 'Lote',
      tabs_disabled_hint: 'Selecione um aviário para habilitar',
      dashboard_heading: 'Visão geral das pesagens',
      dashboard_overview_badge: 'Todos os aviários',
      dashboard_flocks_in_weighing: 'Lotes em pesagem',
      dashboard_avg_uniformity: 'Uniformidade média',
      dashboard_avg_deviation: 'Desvio médio vs. curva',
      dashboard_best_flock: 'Melhor desempenho',
      dashboard_least_uniform_flock: 'Lote menos uniforme',
      dashboard_underperforming_flock: 'Lote abaixo da curva',
      dashboard_uniformity_hint: 'Uniformidade = coeficiente de variação (CV); menor é melhor.',
      dashboard_deviation_hint: 'Desvio = peso médio vs. peso esperado da linhagem na mesma idade; acima da curva é melhor.',
      deviation_dialog_title: 'Desvio vs. curva de referência',
      deviation_dialog_intro: 'Compara o peso médio do lote com o peso esperado da linhagem na mesma idade.',
      deviation_dialog_relevance: 'Como considera a idade e a genética de cada lote, permite comparar lotes de idades diferentes de forma justa.',
      deviation_dialog_note: 'Acima da curva (verde) indica bom desempenho; abaixo (vermelho) pede atenção.',
      deviation_band_on_or_above: 'No padrão ou acima',
      deviation_band_below: 'Abaixo do padrão',
      deviation_band_well_below: 'Bem abaixo do padrão',
      kpi_info_flocks_in_weighing: 'Número de lotes aos quais você tem acesso que possuem ao menos uma pesagem registrada.',
      kpi_info_avg_deviation: 'Média do desvio do peso médio de cada lote em relação ao peso esperado pela curva de referência da linhagem na idade atual do lote (desvio% = (peso médio − peso da curva) ÷ peso da curva). Como é normalizado por idade e genética, lotes de idades diferentes se comparam de forma justa. Positivo = peso médio acima do padrão (bom); negativo = abaixo. Verde = no padrão ou acima, amarelo = abaixo, vermelho = bem abaixo.',
      kpi_info_best_flock: 'O lote cujo peso médio está mais ACIMA do esperado pela curva de referência da linhagem para a sua idade. O desempenho é medido por esse desvio do peso médio em relação à curva (não pelo peso absoluto). Estar acima da curva é bom (mais pesado que o padrão da linhagem para a idade), por isso aparece em verde, não em vermelho.',
      kpi_info_underperforming_flock: 'O lote cujo peso médio está mais ABAIXO do esperado pela curva de referência da linhagem para a sua idade — o que mais precisa de atenção. O desempenho é medido pelo desvio do peso médio em relação à curva. Abaixo do padrão aparece em amarelo (moderadamente abaixo) ou vermelho (bem abaixo).',
      uniformity_excellent: 'Excelente',
      uniformity_good: 'Boa',
      uniformity_fair: 'Aceitável',
      uniformity_poor: 'Ruim',
      cv_dialog_title: 'Uniformidade do lote (CV)',
      cv_dialog_intro: 'A uniformidade é medida pelo coeficiente de variação (CV) do peso das aves: o desvio padrão dividido pelo peso médio, em porcentagem. Por ser uma razão, permite comparar lotes de idades diferentes.',
      cv_eq_sd: 'desvio padrão',
      cv_eq_mean: 'peso médio',
      cv_dialog_relevance: 'Por que importa: um CV baixo indica um lote homogêneo, que tende a ter melhor conversão alimentar, abate mais previsível e melhor bem-estar. Como referência, cerca de 80% das aves dentro de ±10% da média equivale a um CV de aproximadamente 8%. Quanto menor o CV, mais uniforme (e melhor desenvolvido) está o lote.',
      cv_dialog_note: 'Faixas de referência baseadas em guias de manejo de frangos de corte amplamente difundidos (ex.: Aviagen Ross Broiler Management Handbook; Cobb Broiler Management Guide). Ajuste conforme o padrão da sua integração.',
      sort_by: 'Ordenar por',
      sort_name: 'Nome',
      sort_uniformity: 'Uniformidade',
      sort_deviation: 'Desvio',
      sort_age: 'Idade',
      indicators: 'Indicadores',
      average_weight_indicator: 'Peso médio',
      gain_indicator: 'Ganho de peso',
      max_min_indicator: 'Máx / Mín',
      min_max_indicator: 'Mín / Máx',
      reference_deviation_indicator: 'Desvio da referência',
      reference_target: 'Meta {0}',
      weight_uniformity: 'Uniformidade de peso médio',
      uniformity_by_age: 'Uniformidade por idade',
      weight_sd_chart: 'Peso médio e desvio padrão',
      weight_distribution: 'Distribuição de pesos (último dia)',
      total_birds: 'Total de aves: {0}',
      projected_tag: '(Proj.)',
      export: 'Exportar',
      export_csv: 'Exportar dados (.csv)',
      export_pdf: 'Exportar como PDF',
      range_very_light: 'Muito leve',
      range_light: 'Leve',
      range_ideal: 'Ideal',
      range_heavy: 'Pesado',
      range_very_heavy: 'Muito pesado',
      daily_weight_gain: 'Ganho de peso diário',
      average_weight_chart: 'Peso médio',
      weight_projection: 'Projeção de peso',
      inform_projection_period: 'Informe o período de projeção',
      projection_flock_finished: 'Lote encerrado — projeção disponível apenas para lotes em andamento',
      projection_available_from_age_25: 'A projeção fica disponível a partir da idade 25.',
      date: 'Data',
      days: 'Dias',
      project: 'Projetar',
      projected_weight: 'Peso projetado: {0}g',
      projected_weight_standard: 'Projetado (média): {0}g',
      projected_weight_genetics: 'Projetado (linhagem): {0}g',
      inform_projection_days: 'Informe o número de dias (máximo 5).',
      inform_projection_date: 'Informe a data da projeção (máximo 5 dias).',
      invalid_days: 'O número de dias deve ser entre 1 e 5.',
      invalid_date: 'A data deve ser de 1 a 5 dias a partir de hoje.',
      weights_table: 'Tabela de pesos',
      projection: 'Projeção',
      projection_standard: 'Projeção (ganho médio)',
      projection_genetics: 'Projeção (linhagem)',
      grams: 'g',
      sex: 'Sexo',
      genetics: 'Genética (linhagem)',
      sex_as_hatched: 'Misto (macho e fêmea)',
      sex_male: 'Macho',
      sex_female: 'Fêmea',
      sex_mixed: 'Sexado misto',
      target_curve: 'Curva de referência',
      target_weight: 'Peso alvo',
      reference_curve_hint: 'Sem linhagem informada no lote; exibindo Cobb 500 (a mais comum no Brasil) como referência.',
      reference_curve_official: 'Curva de referência: {0} — objetivos oficiais de desempenho da linhagem.',
      view_source: 'Ver fonte de referência',
      view_source_short: 'Ver fonte',
      view_source_page: 'Ver fonte (pág. {0})',
      deviation_vs_target: 'vs. alvo',
      deviation_above: '{0}% acima do padrão',
      deviation_below: '{0}% abaixo do padrão',
      deviation_on_target: 'No padrão da linhagem',
      projection_follows_curve: 'A projeção por linhagem escala a curva ao peso atual do lote, mantendo a proporção atual em relação ao padrão (não assume que o lote passe a ganhar no ritmo genético); a projeção por ganho médio usa o ganho diário recente.',
      based_on_n_weighings: 'Baseado em {0} pesagens',
      low_sample_warning: 'Poucas pesagens — indicador com baixa confiabilidade.',
      performance_indices: 'Índices de desempenho',
      feed_conversion: 'Conversão alimentar (CA)',
      epef: 'IEP',
      live_birds: 'Aves vivas',
      feed_consumed: 'Ração consumida',
      water_consumption: 'Consumo de água',
      feed_intake_per_bird: 'Ração por ave',
      intake_per_day_reference: '{0}/dia',
      daily_intake_today: 'Hoje até agora: {0}/ave',
      daily_intake_none: 'Sem consumo registrado hoje ainda, ou sem balança de silo instalada.',
      daily_intake_unsupported: 'Consumo diário não é informado pelo controlador SMAAI 5.',
      viability: 'Viabilidade',
      locked_feature: 'Recurso indisponível',
      fcr_requires_silo: 'A conversão alimentar e o IEP exigem medição de silo. Instale uma balança de silo Inobram para desbloquear estes indicadores.',
      water_requires_meter: 'O consumo de água exige um hidrômetro conectado. Fale com a Inobram para habilitar o monitoramento de água.',
      water_feed_ratio: 'Água/ração {0}',
      water_feed_ratio_target: 'alvo 1,6–2,0',
      water_feed_ratio_measuring: 'medindo',
      unlock_hint: 'Requisitos para liberar este recurso:',
      what_is_this: 'O que é isto?',
      info_average_weight: 'Peso médio das aves na última pesagem do dia, calculado pela balança a partir das aves que passaram pela plataforma. É a base para os demais indicadores e para a projeção.',
      info_gain: 'Ganho de peso do dia: diferença entre o peso médio atual e o peso médio da pesagem anterior. Indica o ritmo de crescimento do lote. Comparado ao ganho diário esperado da linhagem na idade do lote (verde no alvo ou até 5% abaixo, amarelo até 15% abaixo, vermelho além).',
      info_feed_intake_per_bird: 'Ração por ave — comparada à referência acumulada da linhagem para a idade do lote (ração do silo ÷ aves vivas). Desvios em qualquer direção merecem atenção: abaixo pode indicar queda de apetite (saúde); acima, desperdício ou descalibração do silo. Verde até ±7%, amarelo até ±15%, vermelho além. Exige medição de silo. O consumo do dia é exibido apenas como referência (acumula durante o dia e zera na virada de idade) e não é informado pelo controlador SMAAI 5.',
      info_max_min: 'Maior e menor peso médio registrado no período analisado, úteis para observar a amplitude e a variação do lote ao longo do tempo.',
      info_reference_deviation: 'Quanto o peso médio atual está acima (+) ou abaixo (−) do peso esperado pela curva genética da linhagem para a idade atual. Verde: até 3%; amarelo: 3% a 7%; vermelho: acima de 7%. Quando o lote não tem genética definida, usa-se a curva padrão Cobb 500.',
      info_live_birds: 'Estimativa de aves vivas no lote: aves alojadas menos a mortalidade acumulada (natural + descarte) registrada nos lançamentos de mortalidade.',
      info_viability: 'Percentual de aves que permanecem vivas em relação ao total alojado (aves vivas ÷ aves alojadas). Quanto maior, menor a perda por mortalidade.',
      info_feed_conversion: 'Conversão alimentar (CA): quilos de ração consumidos por quilo de peso vivo produzido (ração ÷ peso vivo total). Exige medição de silo para calcular a ração consumida. Comparada à CA esperada da linhagem na idade do lote (verde até +3%, amarelo +3–7%, vermelho acima; abaixo da meta é melhor). Sem referência para a idade, usa faixas fixas: ≤ 1,60 boa · 1,60–1,75 média · > 1,75 ruim.',
      info_epef: 'Índice de Eficiência Produtiva: (viabilidade % × peso vivo kg) ÷ (idade × CA) × 100. Resume desempenho, ganho e sobrevivência num único número. Depende da conversão alimentar (medição de silo). Referência: ≥ 350 bom · 300–350 médio · < 300 ruim (400+ excelente).',
      info_water_consumption: 'Volume total de água consumido pelo lote, em litros. Exige um hidrômetro conectado para ser medido. Em controladores SMAAI 5 SMART/PRO, a relação água/ração do dia (litros por kg) é comparada à faixa de referência 1,6–2,0 (verde), 1,4–2,3 (amarelo), fora disso vermelho. Varia com a temperatura (sobe no calor); abaixo pode indicar aves bebendo pouco, acima indica estresse térmico, problema intestinal ou vazamento. O SMAAI 5 não informa a ração diária, então a relação não é exibida.'
    },
    account_deletion: {
      title: 'Excluir sua conta Inobram',
      intro: 'Esta página explica como excluir sua conta do Inobram App e da Plataforma Inobram, desenvolvidos pela Inobram. É a mesma conta nos dois, então excluí-la encerra o acesso a ambos. Você não precisa ter o aplicativo instalado.',
      how_to_request: 'Como excluir sua conta',
      step_sign_in: 'Clique em "Entrar para excluir minha conta" e entre com o e-mail e a senha da sua conta.',
      step_confirm: 'Leia os avisos, marque as duas confirmações e digite sua senha novamente.',
      step_delete: 'Clique em "Excluir conta". A conta e os dados listados abaixo são excluídos na hora.',
      sign_in_to_delete: 'Entrar para excluir minha conta',
      cannot_sign_in: 'Não consegue entrar? Envie um e-mail para',
      cannot_sign_in_details: 'a partir do endereço cadastrado na conta, com o assunto "Exclusão de conta". Confirmaremos a exclusão por e-mail em até 15 dias.',
      email_subject: 'Exclusão de conta',
      what_is_deleted: 'O que é excluído',
      deleted_account: 'Sua conta: e-mail de acesso, nome, telefone e senha.',
      deleted_owned_properties: 'As propriedades, núcleos e galpões dos quais você é Proprietário, com seus lotes, lançamentos de mortalidade e silos. Os outros usuários perdem o acesso a eles.',
      deleted_owned_devices: 'Os equipamentos dos quais você é Proprietário, seus dados de cadastro e assinaturas.',
      deleted_shared_access: 'Seu acesso a propriedades e equipamentos compartilhados com você.',
      deleted_settings: 'Suas configurações de notificação, os registros dos seus dispositivos para notificações e suas sessões.',
      what_is_kept: 'O que é mantido',
      kept_device_readings: 'As leituras e os alarmes gravados pelos controladores pertencem ao equipamento, não à sua conta, e deixam de estar ligados a você.',
      kept_legal_records: 'Registros fiscais e de cobrança, quando houver, são mantidos pelo prazo exigido por lei.',
      signed_in_as: 'Você está conectado como',
      warning: 'A exclusão é definitiva e não pode ser desfeita. Você perderá o acesso ao Inobram App e à Plataforma Inobram. As propriedades e os equipamentos dos quais você é Proprietário serão excluídos, e todos os usuários perderão o acesso a eles.',
      understand_loss: 'Estou ciente de que perderei o acesso a todos os produtos digitais Inobram',
      want_delete: 'Sim, quero excluir esta conta Inobram e todos os dados contidos nela',
      current_password: 'Senha atual',
      delete_account: 'Excluir conta',
      error_wrong_password: 'Senha incorreta.',
      error_too_many_attempts: 'Muitas tentativas. Aguarde alguns minutos e tente novamente.',
      error_deleting: 'Não foi possível excluir sua conta. Tente novamente ou envie um e-mail para {email}.',
      deleted_title: 'Conta excluída',
      deleted_message: 'Sua conta Inobram e os dados ligados a ela foram excluídos.'
    }
  },
  en_US: {
    message: {
      batch_number_is_required: 'Batch number is required',
      device_is_required: 'Device is required',
      barn_is_required: 'Barn is required',
      initial_date_is_required: 'Initial date is required',
      initial_hour_is_required: 'Initial hour is required',
      final_date_is_required: 'Final date is required',
      final_hour_is_required: 'Final hour is required',
      state_is_required: 'State is required',
      quantity_housed_is_required: 'Quantity housed is required',
      quantity_housed_must_be_an_integer: 'Quantity housed must be an integer',
      quantity_housed_must_be_greater_than_or_equal_to_zero: 'Quantity housed must be greater than or equal to zero',
      quantity_housed_must_be_less_than_or_equal_to_1000000: 'Quantity housed must be less than or equal to 1000000',
      loading: 'Loading...',
      curtain: 'Curtain',
      water_temperature: 'Water temperature',
      external_temperature: 'External temperature',
      external_humidity: 'External humidity',
      external_temp: 'External Temp.',
      external_humid: 'External Humid.',
      water_temp: 'Water temp.',
      curtain_opening_percentage: 'Curtain opening percentage',
      line: 'Line',
      bar: 'Bar',
      area: 'Area',
      opened: 'Open',
      closed: 'Closed',
      batch_number: 'Batch number',
      finished: 'Finished',
      in_progress: 'In progress',
      running: 'Running',
      from: 'from',
      confirming_action_cannot_undone: 'By confirming, this action cannot be undone.',
      status: 'Status',
      side: 'Side',
      wind: 'Wind',
      weight_percentage_heavy: 'Heavy',
      weight_percentage_light: 'Light',
      weight_percentage_very_heavy: 'Very heavy',
      weight_percentage_very_light: 'Very light',
      weight_distribution: 'Weight distribution',
      weight_percentage: 'Weight Percentage',
      daily_weight_gain: 'Daily weight gain',
      weight_gain: 'Weight gain',
      average_weight: 'Average weight',
      maximum_weight: 'Maximum weight',
      minimum_weight: 'Minimum weight',
      maximum_and_minium_weights: 'Maximum and minimum weights',
      maximum_and_minimum_temperatures: 'Maximum and minimum temperatures',
      maximum_and_minimum_humidities: 'Maximum and minimum humidities',
      maximum_and_minimum_co2: 'Maximum and minimum CO2',
      chart: 'Chart',
      charts: 'Charts',
      correlations: 'Correlations',
      environment: 'Environment',
      performance: 'Performance',
      email_must_be_valid: 'Email must be valid',
      internet_connection: 'Internet connection',
      latitude: 'Latitude',
      longitude: 'Longiturde',
      responsible_contact: 'Responsible contact',
      responsible_phone: 'Responsible phone',
      responsible_email: 'Responsible email',
      owner: 'Owner',
      birth_day: 'Birth day',
      change: 'Change',
      account: 'Account',
      entries: 'Entries',
      width: 'Width',
      height: 'Height',
      length: 'Length',
      date: 'Date',
      initial_date: 'Initial date',
      final_date: 'Final date',
      initial_hour: 'Initial hour',
      final_hour: 'Final hour',
      reading: 'Reading',
      readings: 'Readings',
      statistic: 'Statistic',
      statistics: 'Statistics',
      inobram_platform: 'Inobram Platform',
      platform: 'Platform',
      enter: 'Enter',
      forgot_my_password: 'I forgot my password',
      access_demo: 'Access the demo',
      recover_password: 'Recover password',
      recover_password_in_app_instructions: 'To recover your password, use the "I forgot my password" option in the Inobram App. Enter your registered email or phone number, receive the verification code and set a new password.',
      add: 'Add',
      add_device: 'Add Device',
      list_devices: 'List Devices',
      device: 'Device',
      devices: 'Devices',
      equipment: 'Equipment',
      equipments: 'Equipment',
      type: 'Type',
      description: 'Description',
      indicates_that_the_field_is_required: '*Indicates that the field is required',
      create_your_account: 'Create your account',
      create: 'Create',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      save_for_all: 'Save for all',
      name: 'Name',
      password: 'Password',
      confirm_the_password: 'Confirm the password',
      password_must_be_at_least_6_characters: 'Password must be at least 6 characters',
      the_password_is_invalid_or_the_user_does_not_have_a_password: 'The password is invalid or the user does not have a password.',
      the_email_address_is_badly_formatted: 'The email address is badly formatted.',
      there_is_no_user_record_corresponding_to_this_identifier_the_user_may_have_been_deleted: 'There is no user record corresponding to this identifier. The user may have been deleted.',
      profile: 'Profile',
      add_nucleus: 'Add nucleus',
      list_nuclei: 'List nuclei',
      nuclei: 'Nuclei',
      nucleus: 'Nucleus',
      add_property: 'Add property',
      edit_property: 'Edit property',
      property: 'Property',
      properties: 'Properties',
      users: 'Users',
      add_user: 'Add user',
      updated_at: 'Updated at',
      reports_and_settings: 'Reports and settings',
      establishing_remote_access_session: 'Establishing remote access session',
      remote_access_failed: 'Could not establish the remote access session. Check whether the device is online.',
      only_owner_can_remote_access: 'Only the device owner can remote access the controller',
      water_consumption_today: 'Water consumption today',
      water_consumption: 'Water consumption',
      daily_water_consumption: 'Daily water consumption',
      feed_level: 'Feed level',
      yes: 'Yes',
      no: 'No',
      alerts: 'Alerts',
      settings: 'Settings',
      not_connected: 'Not connected',
      inobram_account: 'Inobram account',
      navigation_menu: 'Navigation menu',
      exit: 'Exit',
      added_at: 'Added at',
      added_by: 'Added by',
      edit: 'Edit',
      delete: 'Delete',
      delete_mortality_from_date: 'Delete mortality from date',
      close: 'Close',
      all: 'All',
      rows_per_page: 'Rows per page',
      no_data: 'No data available',
      items_to_show: 'Items to show',
      chage_view_mode: 'Change view mode',
      setting_alarm_value: 'Setting alarm value',
      invalid_mac: 'Invalid MAC',
      invalid_mac_pattern: 'Invalid MAC pattern',
      to_view: 'To View',
      minimum: 'Minimum',
      maximum: 'Maximum',
      alarm_level: 'Alarm level',
      next: 'Next',
      previous: 'Previus',
      countries: 'Countries',
      states: 'States',
      cities: 'Cities',
      sexes: 'Sexes',
      country: 'Country',
      state: 'State',
      city: 'City',
      sex: 'Sex',
      device_models: 'Device models',
      device_types: 'Device types',
      mortalities: 'Mortalities',
      device_model: 'Device model',
      device_type: 'Device type',
      mortality: 'Mortality',
      daily_mortality: 'Daily mortality',
      culling_deaths: 'Culling deaths',
      culling: 'Culling',
      natural_deaths: 'Natural deaths',
      natural: 'Natural',
      quantity: 'Quantity',
      quantity_housed: 'Quantity housed',
      batch: 'Batch',
      batches: 'Batches',
      wall: 'Wall',
      walls: 'Walls',
      floor: 'Floor',
      floors: 'Floors',
      roof: 'Roof',
      roofs: 'Roofs',
      inner_curtain: 'Inner curtain',
      inner_curtains: 'Inner curtains',
      outer_curtain: 'Outer curtain',
      outer_curtains: 'Outer curtains',
      lining: 'Lining',
      linings: 'Linings',
      evaporative_plate: 'Evaporative plate',
      evaporative_plates: 'Evaporative plates',
      lighting_system: 'Lighting system',
      lighting_systems: 'Lighting systems',
      internet_access_type: 'Internet access type',
      internet_access_types: 'Internet access types',
      barn: 'Barn',
      barns: 'Barns',
      filter_by_property: 'Filter by property',
      filter_by_nucleus: 'Filter by nucleus',
      filter_by_country: 'Filter by country',
      filter_by_state: 'Filter by state',
      filter_by_city: 'Filter by city',
      location: 'Location',
      structure: 'Structure',
      filters: 'Filters',
      view_mode: 'View mode',
      card_view: 'Cards',
      list_view: 'List',
      active_filters: '{count} active filter | {count} active filters',
      clear_filters: 'Clear filters',
      no_barns_found: 'No barns found.',
      barn_type: 'Barn type',
      barn_types: 'Barn types',
      voltage_type: 'Barn type',
      voltage_types: 'Barn types',
      air_inlet: 'Air inlet',
      air_inlets: 'Air inlets',
      silo_type: 'Silo type',
      silo_types: 'Silo types',
      water_box: 'Water box',
      water_boxes: 'Water boxes',
      watchdog_system: 'Watchdog system',
      watchdog_systems: 'Watchdog systems',
      batch_state: 'Batch state',
      batch_states: 'Batch states',
      capacity: 'Capacity',
      capacity_estimated: 'estimated',
      manufacturer: 'Manufacturer',
      manufacturers: 'Manufacturers',
      ok: 'OK',
      copied_to_the_clipboard: 'copied to the clipboard.',
      error_copying_text: 'Error copying text.'
    },
    notification_history: {
      notifications: 'Notifications',
      unread_count: '{count} unread',
      mark_all_as_read: 'Mark all as read',
      no_notifications: 'You have no notifications yet',
      load_error: 'Could not load the notifications',
      see_all: 'All notifications',
      load_more: 'Load more',
      notified_at: 'Notified at {time}',
      viewed_at: 'Viewed on {time}',
      delivery_sent: 'Delivered',
      delivery_failed: 'Delivery failed',
      delivery_no_device: 'Not sent: no device signed in'
    },
    alarm: {
      alarm: 'Alarm',
      alarms: 'Alarms',
      active_alarms: 'Active Alarms',
      alarms_and_notifications: 'Alarms & Notifications',
      see_all: 'View All',
      mute: 'Mute',
      mute_all: 'Mute all',
      unmute: 'Unmute',
      reactivate_all: 'Reactivate all',
      alarm_history: 'Alarm History',
      tab_analysis: 'Alarm Analysis',
      no_active_alarms: 'There are no active alarms at the moment',
      no_alarm_history: 'No alarms recorded in this period',
      select_barn_and_batch: 'Select a barn and a batch to view the alarm history',
      all_barns: 'All Barns',
      select_batch: 'Select a Batch',
      sort_by: 'Sort by:',
      sort_date: 'Date',
      sort_name: 'Name',
      date_time: 'Date/Time',
      alarms_per_page: 'Alarms per page',
      current: 'Current',
      updated_just_now: 'Updated just now',
      updated_seconds_ago: 'Updated {count}s ago',
      updated_minutes_ago: 'Updated {count} min ago',
      updated_at: 'Updated at {time}',
      overview_last_24h: 'Overview · Last 24h · All barns',
      new_alarm_flash: 'New alarm!',
      sound_enabled: 'Sound enabled',
      sound_disabled: 'Sound blocked — click to enable',
      sound_unavailable: 'Sound unavailable in this browser',
      alarms_silenced: 'Alarms silenced',
      filters: 'Filters',
      axis_date: 'Date',
      axis_age: 'Batch Age',
      start_date: 'Start date',
      start_time: 'Start time',
      end_date: 'End date',
      end_time: 'End time',
      age_start: 'Start age',
      age_end: 'End age',
      info_last_days: 'Showing data from the last 7 days. Select a barn and a batch for a more detailed analysis.',
      info_filtered: 'Showing data from the selected barn and batch.',
      clear_all_filters: 'Clear all filters',
      export: 'Export',
      export_csv: 'Export CSV',
      export_pdf: 'Export PDF',
      report_title: 'Alarms Report',
      report_generated_at: 'Generated at',
      report_period: 'Period',
      report_summary: 'Summary',
      charts: 'Charts',
      total_alarms: 'Total Alarms',
      alarm_records: 'Alarm records',
      alarm_peak: 'Alarm Peak',
      alarms_per_day: 'Alarms p/day',
      alarms_label: 'alarms',
      timeline_title: 'Alarm Timeline',
      distribution_by_barn: 'Alarm Distribution by Barn',
      distribution_title: 'Alarm Distribution',
      alarm_type: 'Alarm Type',
      quantity: 'Quantity',
      proportion: 'Proportion',
      total: 'Total',
      page: 'Page',
      heatmap_title: 'Heat Map - Critical Hours',
      low_quantity: 'Low Quantity',
      high_quantity: 'High Quantity',
      details_title: 'Alarm Details',
      details_inobramx_note: 'Resolution and desired environment columns are only populated for SMAAI 5 PRO/SMART controllers. For other models these fields appear as “-”.',
      col_resolved_at: 'Resolved at',
      col_alarm_value: 'Alarm value',
      col_temp_desired: 'Desired Temp. (°C)',
      col_temp_avg: 'Avg. Temp. (°C)',
      col_humidity_desired: 'Desired Hum. (%)',
      col_humidity_avg: 'Avg. Hum. (%)',
      col_pressure_desired: 'Desired Press. (pa)',
      col_pressure_avg: 'Avg. Press. (pa)',
      col_co2: 'CO2 (ppm)',
      high_temperature: 'High temperature',
      low_temperature: 'Low temperature',
      high_humidity: 'High humidity',
      low_humidity: 'Low humidity',
      high_pressure: 'High pressure',
      low_pressure: 'Low pressure',
      low_battery: 'Low battery',
      low_source: 'Energy fault',
      no_probe_installed: 'No probe installed',
      null_temperature: 'Temperature zero',
      probe_error: 'Probe error',
      relay_error: 'Relay error',
      LEIT_SONDA: 'Error probe reading',
      INST_SONDA: 'Error probe installation',
      TEMP_ALTA: 'High temperature',
      TEMP_BAIXA: 'Low temperature',
      UMIDADE_ALTA: 'High humidity',
      UMIDADE_BAIXA: 'Low humidity',
      PRESSAO_ALTA: 'High pressure',
      PRESSAO_BAIXA: 'Low pressure',
      BATERIA_BAIXA: 'Low battery',
      FALTA_ENERGIA: 'Power failure',
      DESARME_CORT: 'Curtain disarm',
      ERROR_RELAY: 'Error relay board',
      ERROR_PROBE_TH2O1: 'Error probe TH2O1',
      ERROR_PROBE_TH2O2: 'Error probe TH2O2',
      ERROR_PROBE_TH2O3: 'Error probe TH2O3',
      ERRO_SONDA_TH2O1: 'Error probe TH2O1',
      ERRO_SONDA_TH2O2: 'Error probe TH2O2',
      ERRO_SONDA_TH2O3: 'Error probe TH2O3',
      ERRO_SONDA_T1: 'Error probe T1',
      ERRO_SONDA_T2: 'Error probe T2',
      ERRO_SONDA_T3: 'Error probe T3',
      ERRO_SONDA_T4: 'Error probe T4',
      ERRO_SONDA_T5: 'Error probe T5',
      ERRO_SONDA_TU1: 'Error probe TU1',
      ERRO_SONDA_TU2: 'Error probe TU2',
      ERRO_SONDA_TU3: 'Error probe TU3',
      ERRO_SONDA_U1: 'Error probe U1',
      ERRO_SONDA_U2: 'Error probe U2',
      ERRO_SONDA_P1: 'Error probe P1',
      ERRO_SONDA_CO21: 'Error probe CO21',
      ERRO_SONDA_H2O1: 'Error probe H2O1',
      high_temp: 'High temperature',
      low_temp: 'Low temperature',
      high_hum: 'High humidity',
      low_hum: 'Low humidity',
      high_co2: 'High CO2',
      fault_energy: 'Power failure',
      low_bat: 'Low battery',
      over_voltage: 'Over voltage',
      ve_error: 'Error wind sensor',
      co2_error: 'Error probe CO2',
      overload: 'Overload',
      t1_error: 'Error probe T1',
      t2_error: 'Error probe T2',
      t3_error: 'Error probe T3',
      t4_error: 'Error probe T4',
      th2o1_error: 'Erro probe TH2O1',
      th2o2_error: 'Erro probe TH2O2',
      th2o3_error: 'Erro probe TH2O3',
      tu1_error: 'Erro probe TU1',
      tu2_error: 'Erro probe TU2',
      tu3_error: 'Erro probe TU3',
      tu4_error: 'Erro probe TU4',
      u1_error: 'Erro probe U1',
      u2_error: 'Erro probe U2',
      ve1_error: 'Erro probe VE1'
    },
    notification: {
      attention: 'Attention',
      confirm_exclusion: 'Confirm exclusion?',
      deleted_successfully: 'Deleted successfully!',
      saved_successfully: 'Saved successfully!',
      there_was_an_error_saving: 'There was an error saving',
      there_was_an_error: 'There was an error',
      discontinued_add_device_warning: 'To add devices, use the InoBram App'
    },
    card_legend: {
      title: 'Understanding the card indicators',
      intro: 'Each gauge and bar changes color according to the status of its variable. Here is the logic for each: Use the settings (gear) button to choose which optional metrics appear on the cards.',
      button: 'Card legend',
      state: {
        ideal: 'Ideal',
        attention: 'Attention',
        critical: 'Critical',
        reference: 'Reference',
        no_data: 'No data'
      },
      temperature: {
        title: 'Temperature',
        desc: 'The ring shows how far the current temperature is from the desired temperature.',
        ideal: 'Within ±1 °C of the desired temperature.',
        attention: 'Between ±1 °C and ±2 °C from the desired temperature.',
        critical: 'More than ±2 °C from the desired temperature.',
        reference: 'Shown in blue when no desired temperature is configured.'
      },
      humidity: {
        title: 'Humidity',
        desc: 'The ring fills with the current relative humidity, colored by the distance from the target.',
        ideal: 'Within ±5% of the target humidity.',
        attention: 'Between ±5% and ±10% from the target humidity.',
        critical: 'More than ±10% from the target humidity.',
        reference: 'Shown in blue when no target humidity is configured.'
      },
      co2: {
        title: 'CO₂',
        desc: 'The ring fills with the CO₂ concentration; the red mark is the high threshold.',
        ideal: 'Up to 1500 ppm (good air quality).',
        attention: 'Between 1500 and 2500 ppm (moderate air quality).',
        critical: 'Above 2500 ppm (high CO₂).',
        no_data: 'Shown in grey when no reading is available.'
      },
      feels_like: {
        title: 'Apparent temperature (feels like)',
        desc: 'Temperature the birds actually feel, combining heat and humidity. Compared against the desired temperature.',
        equation: 'AT = T + 0.33 × e − 4.00\ne = (RH / 100) × 6.105 × exp(17.27 × T / (237.7 + T))',
        where: 'T = temperature (°C); RH = relative humidity (%); e = vapour pressure (hPa). Steadman apparent temperature (indoor, no wind).',
        ideal: 'Within ±1 °C of the desired temperature.',
        attention: 'Between ±1 °C and ±2 °C from the desired temperature.',
        critical: 'More than ±2 °C from the desired temperature.',
        reference: 'Shown in blue when no desired temperature is configured.'
      },
      thi: {
        title: 'THI (Temperature-Humidity Index)',
        desc: 'Heat-stress indicator that combines temperature and humidity into a single figure.',
        equation: 'THI = T − (0.31 − 0.0031 × RH) × (T − 14.4)',
        where: 'T = temperature (°C); RH = relative humidity (%). Adapted from NRC (1971) / Marai et al. (2001) for poultry.',
        ideal: 'Below 27 (no heat stress).',
        attention: 'Between 27 and 29 (heat alert).',
        critical: 'At or above 29 (heat stress).'
      },
      enthalpy: {
        title: 'Enthalpy',
        desc: 'Total heat energy of the air (sensible + latent) that the bird must dissipate. Higher values make heat exchange harder.',
        equation: 'h = 1.006 × T + W × (2501 + 1.805 × T)\nW = 0.622 × Pv / (Patm − Pv)',
        where: 'W = humidity ratio (kg water / kg dry air); Pv = vapour pressure; Patm = 101.325 kPa. The comfort band is age-dependent (Rodrigues et al. 2011).',
        reference: 'Informational value (blue): the ideal band depends on the flock age.'
      },
      ventilation: {
        title: 'Ventilation',
        desc: 'Combined air-quality signal. High CO₂ means poor air exchange; together with high humidity it points to insufficient ventilation (typical of cold-weather minimum ventilation).',
        equation: 'CO₂ > 2500 ppm  ⇒  Poor\nCO₂ > 1500 ppm  or  high RH  ⇒  Moderate',
        where: 'High RH = 10% above target (or above 70% with no target). Combines CO₂ and humidity.',
        ideal: 'CO₂ and humidity under control (good ventilation).',
        attention: 'Moderate CO₂ or elevated humidity (moderate ventilation).',
        critical: 'High CO₂, often with high humidity (poor ventilation).',
        no_data: 'Shown in grey when no CO₂ reading is available.'
      },
      silo: {
        title: 'Silos',
        desc: 'Bars fill with the feed level as a percentage of the silo capacity (20,000 kg when no capacity is configured).',
        ideal: 'At or above 30% of capacity.',
        attention: 'Between 15% and 30% of capacity.',
        critical: 'Below 15% of capacity.'
      },
      metrics: {
        title: 'Age, pressure, water and weight',
        desc: 'Informational values with no color states: flock age (days), static pressure (Pa), water consumed today (L) and average bird weight (g). Pressure and water can be hidden in the card settings.'
      }
    },
    card_settings: {
      button: 'Card settings',
      title: 'Metrics shown on the cards',
      intro: 'Choose which optional metrics appear on each device card.',
      reset: 'Reset to default',
      pressure: { title: 'Static pressure', desc: 'Ventilation static pressure (Pa).' },
      water: { title: 'Water', desc: 'Water consumed today (L).' },
      feelsLike: { title: 'Apparent temperature', desc: 'Feels-like temperature combining heat and humidity.' },
      thi: { title: 'THI', desc: 'Temperature-Humidity Index (heat-stress indicator).' },
      enthalpy: { title: 'Enthalpy', desc: 'Total heat load of the air (kJ/kg dry air).' },
      ventilation: { title: 'Ventilation', desc: 'Air-quality signal from CO₂ and humidity.' }
    },
    comfort: {
      feels_like: 'Feels like',
      feels_like_tip: 'Apparent temperature (feels like): combines heat and humidity.',
      thi: 'THI',
      thi_tip: 'Temperature-Humidity Index — heat-stress indicator.',
      enthalpy: 'Enthalpy',
      enthalpy_tip: 'Air enthalpy (kJ/kg dry air) — total heat load.',
      ventilation: 'Ventilation',
      ventilation_tip: 'Ventilation quality from CO₂ and humidity.',
      ventilation_good: 'Good',
      ventilation_moderate: 'Moderate',
      ventilation_poor: 'Poor',
      ventilation_no_data: '--'
    },
    environment: {
      age: 'Age',
      days: 'days',
      temperature: 'Temperature',
      humidity: 'Humidity',
      pressure: 'Pressure',
      co2: 'CO2',
      air_quality_good: 'Good air quality',
      air_quality_moderate: 'Moderate air quality',
      air_quality_high: 'High CO2',
      water: 'Water',
      weight: 'Weight',
      desired_weight: 'Desired weight',
      silo: 'Silo',
      silos: 'Silos',
      desired_temperature: 'Desired temperature',
      desired_temperature_prefix: 'Des. temperature',
      maximum_temperature: 'Maximum temperature',
      minimum_temperature: 'Minimum temperature',
      desired_humidity: 'Desired humidity',
      desired_humidity_prefix: 'Des. humidity',
      maximum_humidity: 'Maximum humidity',
      minimum_humidity: 'Minimum humidity',
      desired_pressure: 'Desired pressure',
      desired_pressure_prefix: 'Des. pressure',
      maximum_co2: 'Maximum CO2',
      minimum_co2: 'Minimum CO2',
      average_temperature: 'Average temperature',
      average_temperature_internal: 'Internal avg. temp.',
      average_temperature_external: 'External avg. temp.',
      average_humidity: 'Average humidity',
      average_humidity_internal: 'Internal avg. humidity',
      average_humidity_external: 'External avg. humidity',
      average_co2: 'Average CO2',
      temperature_range: 'Temperature range',
      temperature_range_internal: 'Internal temp. range',
      humidity_range: 'Humidity range',
      humidity_range_internal: 'Internal humidity range',
      co2_range: 'CO2 range',
      weight_range: 'Weight range',
      range_to: 'to',
      show_external: 'Show external',
      external_temperature_range: 'External temp. range',
      external_humidity_range: 'External humidity range',
      delta_temperature: 'Delta temperature (int - ext)',
      delta_humidity: 'Delta humidity (int - ext)',
      delta_temperature_desired: 'Δ desired - average',
      delta_humidity_desired: 'Δ desired - average',
      weight_gain_vs_temp: 'Weight gain vs temperature deviation',
      temp_deviation: 'Temperature deviation (°C)',
      mortality_vs_environment: 'Mortality vs temperature/humidity',
      temp_deviation_short: 'Δ Temperature',
      humidity_deviation_short: 'Δ Humidity',
      water_vs_temp: 'Water consumption vs temperature',
      water_liters: 'Water (l)',
      avg_temp: 'Avg. temp. (°C)',
      uniformity_vs_co2: 'Weight uniformity vs CO2',
      weight_cv: 'Weight CV (%)',
      avg_co2: 'Avg. CO2 (ppm)',
      water_per_bird_vs_gain: 'Water per bird vs weight gain',
      water_per_bird: 'Water/bird (ml)',
      weight_gain_vs_humidity: 'Weight gain vs humidity deviation',
      humidity_deviation: 'Humidity deviation (%)',
      quantity_housed: 'Quantity housed'
    },
    prefix: {
      ag: 'Ag',
      dt: 'Dt',
      at: 'T',
      dh: 'Dh',
      ah: 'H',
      wt: 'Wt (L)',
      dw: 'Dw (g)',
      aw: 'Aw (g)',
      dp: 'Dp (Pa)',
      ap: 'P (Pa)',
      s1: 'S1',
      s2: 'S2',
      st: 'Status',
      t_max: 'T max',
      t_min: 'T min',
      h_max: 'H max',
      h_min: 'H min',
      p_max: 'P max',
      p_min: 'P min',
      co2_max: 'co2 max',
      co2_min: 'co2 min',
      h2o_acc: 'h2o accumulated'
    },
    table: {
      of: 'of',
      all: 'All',
      rows_per_page_text: 'Rows per page',
      quantity_per_page_text: 'Quantity per page'
    },
    banner_premium_plan: {
      platform: 'Platform',
      info: '\nFor more details about the availability of this feature, please contact our team through the following contact:\n',
      get_in_touch: 'Get in\ntouch'
    },
    insights: {
      title: 'Batch insights',
      no_insights: 'No insights for this batch',
      heat_stress: '{count} day(s) with heat stress detected',
      heat_stress_detail: 'Average temperature exceeded setpoint by more than 2°C on ages: {ages}',
      co2_breach: '{count} day(s) with CO₂ above 2500 ppm',
      co2_breach_detail: 'High concentration may cause respiratory stress. Ages: {ages}',
      humidity_out_of_range: '{count} day(s) with humidity out of ideal range',
      humidity_detail: 'Average deviation above 10% from setpoint on ages: {ages}',
      uniformity_alert: '{count} day(s) with low weight uniformity (CV > 10%)',
      uniformity_detail: 'Worst day: age {age} with CV of {cv}%',
      growth_decline: 'Sharp decline in weight gain',
      growth_decline_detail: 'Peak of {peakGain}g/day at age {peakAge}, dropped to {currentGain}g/day',
      peak_growth: 'Peak daily gain: {gain}g at age {age}',
      water_gain_spike: '{count} day(s) with water-to-gain ratio above normal',
      water_gain_spike_detail: 'Elevated consumption relative to gain on ages: {ages}',
      mortality_spike: '{count} day(s) with mortality above average',
      mortality_spike_detail: 'Spikes on ages: {ages} (batch average: {avg}/day)',
      total_mortality: 'Cumulative mortality of {pct}% of the flock',
      info_title: 'How insights work',
      info_intro: 'The platform automatically analyzes batch data and generates insights when it identifies conditions that may impact performance. Below are all the insights the system can generate:',
      info_heat_stress_title: 'Heat stress',
      info_heat_stress_desc: 'Compares the average internal temperature (average of daily max and min) with the configured temperature setpoint. Flags when the average exceeds the setpoint by more than 2°C. Becomes critical when 3 or more days show this condition.',
      info_co2_title: 'Elevated CO₂',
      info_co2_desc: 'Monitors the daily maximum CO₂ concentration. Flags when the peak exceeds 2500 ppm, a level that can cause respiratory stress in birds. Becomes critical with 3 or more days above the threshold.',
      info_humidity_title: 'Humidity out of range',
      info_humidity_desc: 'Calculates the deviation of average internal humidity from the configured setpoint. Flags when the absolute deviation exceeds 10 percentage points. Becomes a warning with 5 or more days out of range.',
      info_uniformity_title: 'Weight uniformity',
      info_uniformity_desc: 'Calculates the coefficient of variation (CV% = standard deviation / average weight × 100) from daily weighing data, ignoring the first week of life (early weight spread is natural). Flags when CV exceeds 10%, indicating the flock may be non-uniform.',
      info_growth_title: 'Weight gain decline',
      info_growth_desc: 'Identifies the peak daily weight gain and flags if the current gain has dropped below 60% of that peak within the last 5 days, which may indicate health or nutritional issues. Also reports the peak gain day as a reference.',
      info_peak_growth_title: 'Peak daily gain',
      info_peak_growth_desc: 'Reports the age and value of the highest daily weight gain recorded in the batch, serving as a reference for evaluating the growth curve.',
      info_water_gain_title: 'Water-to-gain ratio',
      info_water_gain_desc: 'Calculates the ratio between water consumption and daily weight gain and compares it against the flock\'s own recent trend (average of the preceding days), ignoring the first week of life. Flags when the ratio rises abruptly (more than 1.35× the recent trend) for at least 2 days, which may indicate health or thermal comfort issues.',
      info_mortality_title: 'Mortality',
      info_mortality_desc: 'Monitors daily mortality, ignoring the first week of life (brooding mortality is naturally higher). Flags when a day records more than double the post-brooding average (critical above triple). Also tracks cumulative mortality: warning above 3% and critical above 5% of total housed.',
      info_severity_title: 'Severity levels:',
      info_severity_critical: 'Critical — requires immediate attention',
      info_severity_warning: 'Warning — deserves monitoring',
      info_severity_info: 'Informational — reference data'
    },
    chart_dialog: {
      mortality_dialog: 'This chart displays the mortality for each batch age, differentiating between mortalities due to culling and those due to natural causes.',
      water_consumption_dialog: 'This chart displays the water consumption for each batch age.',
      weight_distribution_dialog: 'This chart displays the weight distribution in percentage levels for each probe at each batch age.',
      weight_gain_dialog: 'This chart displays the weight gain for each age.',
      average_weight_dialog: 'This chart displays the average weight for each age, as well as the highest and lowest recorded weights for that age.',
      co2_dialog: 'This chart displays the average CO2 for each age, as well as the highest and lowest recorded CO2 averages for that age.',
      humidity_dialog: 'This chart displays the average humidity for each age, as well as the highest and lowest recorded humidity averages for that age.',
      temperature_dialog: 'This chart displays the average temperature for each age, as well as the highest and lowest recorded temperature averages for that age.',
      mortality_dialog_title: 'Mortality Chart',
      water_consumption_dialog_title: 'Daily Water Consumption Chart',
      weight_distribution_dialog_title: 'Weight Distribution Chart',
      weight_gain_dialog_title: 'Daily Weight Gain Chart',
      average_weight_dialog_title: 'Average Weight Chart',
      co2_dialog_title: 'CO2 Chart',
      humidity_dialog_title: 'Humidity Chart',
      temperature_dialog_title: 'Temperature Chart',
      weight_gain_vs_temp_dialog: 'Correlates daily weight gain with the average temperature deviation from setpoint. Helps identify how heat stress affects performance.',
      weight_gain_vs_temp_dialog_title: 'Weight gain vs temperature deviation',
      mortality_vs_env_dialog: 'Overlays daily mortality with temperature and humidity deviations from setpoints. Helps identify environmental causes of mortality.',
      mortality_vs_env_dialog_title: 'Mortality vs environment',
      water_vs_temp_dialog: 'Correlates water consumption with average internal temperature. Birds consume more water at higher temperatures — deviations from the pattern may indicate issues.',
      water_vs_temp_dialog_title: 'Water consumption vs temperature',
      uniformity_vs_co2_dialog: 'Correlates the weight coefficient of variation (uniformity) with average CO2. High CO2 levels may reduce flock uniformity.',
      uniformity_vs_co2_dialog_title: 'Uniformity vs CO2',
      water_per_bird_vs_gain_dialog: 'Shows the relationship between water consumption per bird and weight gain. A rising ratio may indicate stress, disease, or feed issues.',
      water_per_bird_vs_gain_dialog_title: 'Water per bird vs weight gain',
      weight_gain_vs_humidity_dialog: 'Correlates weight gain with humidity deviation from setpoint. High humidity reduces birds\' thermoregulation ability.',
      weight_gain_vs_humidity_dialog_title: 'Weight gain vs humidity deviation'
    },
    aei: {
      dashboard: 'Dashboard',
      filter_by_complex: 'Filter by complex',
      filter_by_site: 'Filter by site',
      no_filter_match: 'No house matches the filters.',
      house_count: '1 house | {count} houses',
      machine_count: '1 machine | {count} machines',
      kpi: {
        feed: 'Feed',
        temperature: 'Temperature',
        humidity: 'Humidity',
        co2: 'CO₂',
        nh3: 'NH₃',
        water: 'Water',
        outside_temp: 'Outside temp.',
        static_pressure: 'Pressure',
        cooler_temp: 'Cooler',
        ph: 'pH',
        water_temp: 'Water temp.',
        flow_efficiency: 'Flow efficiency',
        run_time_efficiency: 'Run time efficiency',
        total_cases: 'Cases',
        stops: 'Stops',
        concentration: 'Sanitizer',
        recirculation_temp: 'Recirculation temp.',
        water_flow: 'Water flow',
        ph_target: 'pH target',
        run_time: 'Run time',
        sanitizer_flow: 'Sanitizer flow',
        undiluted_concentration: 'Undiluted sanitizer'
      },
      feed_bins: 'Feed bins',
      houses: 'Houses',
      processing: 'Processing room',
      title: 'AEI Integra',
      total_feed: 'Total feed',
      bin: 'Bin',
      no_houses: 'No house has reported data yet.',
      no_readings: 'No readings available.',
      no_processing: 'No processing equipment has reported data yet.',
      stale: 'Stale',
      stale_hint: 'The latest reading is more than 12 hours old.',
      measured_at: 'Measured at',
      updated_just_now: 'Updated just now',
      updated_minutes: 'Updated {count} min ago',
      updated_hours: 'Updated 1 hour ago | Updated {count} hours ago',
      updated_days: 'Updated 1 day ago | Updated {count} days ago',
      gateway_seen_just_now: 'Last upload just now',
      gateway_seen_minutes: 'Last upload {count} min ago',
      gateway_seen_hours: 'Last upload 1 hour ago | Last upload {count} hours ago',
      gateway_seen_days: 'Last upload 1 day ago | Last upload {count} days ago',
      gateway_never_seen: 'No uploads received yet',
      last_reading: 'Last reading',
      loading: 'Loading...',
      records: {
        feed_bin: 'Feed bins',
        environment: 'Environment',
        water_use: 'Water use',
        feed_use: 'Feed use',
        feed_delivered: 'Feed deliveries',
        alarm: 'Alarms',
        chicken: 'Flock',
        flock: 'Housing',
        egg: 'Egg counts',
        tier_egg: 'Egg gathering',
        fan: 'Fans',
        heater: 'Heaters',
        cool_cell: 'Cool cells and pumps',
        vfd_fan: 'Ventilation speed',
        light: 'Lights',
        power: 'Outputs',
        sensor: 'Temperature sensors',
        group: 'Temperature zones',
        maintenance: 'Maintenance'
      },
      back_to_houses: 'Houses',
      metric: 'Metric',
      value: 'Value',
      plan_inactive: 'The AEI plan for this complex is not active. Data is no longer being received; history remains available.',
      devices_without_plan: 'No devices without an active plan. | 1 device without an active plan no longer receives data. | {count} devices without an active plan no longer receive data.'
    },
    bird_weight: {
      title: 'Weighings',
      subtitle: 'Bird weighing',
      all_barns: 'All barns',
      select_barn: 'Barn',
      select_batch: 'Select the batch',
      tab_history: 'Weighing history',
      tab_analysis: 'Weight analysis and projection',
      back_to_overview: 'Weighings',
      no_barn_selected: 'Select a barn to view the weighing history and weight analysis.',
      no_weighings: 'No weighings available.',
      no_batch_selected: 'Select a batch to view the weighings.',
      loading: 'Loading...',
      age: 'Age',
      average_weight: 'Average weight',
      weighing_gain: 'Weight gain',
      weight_count: 'Weighing count',
      max: 'Max weight',
      min: 'Min weight',
      standard_deviation: 'Standard deviation',
      ideal_weight: 'Ideal weight',
      uniformity: 'Uniformity',
      current_weight: 'Current weight: {0}g',
      overview_current_age: 'Current age',
      overview_last_weighing: 'Last weighing',
      overview_uniformity: 'Uniformity',
      overview_deviation: 'Deviation vs. curve',
      overview_no_data: 'No weighings',
      overview_no_data_hint: 'This barn has no weighings recorded yet.',
      overview_open_batch: 'No open batch',
      overview_status_running: 'Running',
      overview_status_closed: 'Closed',
      overview_view_history: 'History and Projection',
      overview_weighing_age: 'Age {0}',
      overview_days: 'days',
      overview_flock: 'Flock',
      tabs_disabled_hint: 'Select a barn to enable',
      dashboard_heading: 'Weighing overview',
      dashboard_overview_badge: 'All barns',
      dashboard_flocks_in_weighing: 'Flocks weighing',
      dashboard_avg_uniformity: 'Average uniformity',
      dashboard_avg_deviation: 'Avg. deviation vs. curve',
      dashboard_best_flock: 'Best performing',
      dashboard_least_uniform_flock: 'Least uniform flock',
      dashboard_underperforming_flock: 'Flock below curve',
      dashboard_uniformity_hint: 'Uniformity = coefficient of variation (CV); lower is better.',
      dashboard_deviation_hint: 'Deviation = average weight vs. the expected weight for the strain at the same age; above the curve is better.',
      deviation_dialog_title: 'Deviation vs. reference curve',
      deviation_dialog_intro: 'Compares the flock average weight with the expected weight for the strain at the same age.',
      deviation_dialog_relevance: 'Because it accounts for the age and genetics of each flock, flocks of different ages can be compared fairly.',
      deviation_dialog_note: 'Above the curve (green) is good; below (red) needs attention.',
      deviation_band_on_or_above: 'On or above standard',
      deviation_band_below: 'Below standard',
      deviation_band_well_below: 'Well below standard',
      kpi_info_flocks_in_weighing: 'Number of flocks you have access to that currently have at least one recorded weighing.',
      kpi_info_avg_deviation: 'Average of each flock deviation of its average weight from the weight expected by the breed reference curve at the flock current age (deviation% = (average weight − curve weight) ÷ curve weight). Because it is normalized by age and genetics, flocks of different ages compare fairly. Positive = average weight above the breed standard (good); negative = below. Green = on or above standard, amber = below, red = well below.',
      kpi_info_best_flock: 'The flock whose average weight is furthest ABOVE the weight expected by its breed reference curve for its age. Performance is measured by that average-weight deviation from the curve (not by absolute weight). Above the curve is good (heavier than the breed standard for its age), which is why it is shown in green, not red.',
      kpi_info_underperforming_flock: 'The flock whose average weight is furthest BELOW the weight expected by its breed reference curve for its age — the one most in need of attention. Performance is measured by the average-weight deviation from the curve. Below the standard is shown in amber (moderately below) or red (well below).',
      uniformity_excellent: 'Excellent',
      uniformity_good: 'Good',
      uniformity_fair: 'Acceptable',
      uniformity_poor: 'Poor',
      cv_dialog_title: 'Flock uniformity (CV)',
      cv_dialog_intro: 'Uniformity is measured by the coefficient of variation (CV) of bird weight: the standard deviation divided by the average weight, as a percentage. Being a ratio, it lets you compare flocks of different ages.',
      cv_eq_sd: 'standard deviation',
      cv_eq_mean: 'average weight',
      cv_dialog_relevance: 'Why it matters: a low CV indicates a homogeneous flock, which tends to have better feed conversion, more predictable processing and improved welfare. As a rule of thumb, about 80% of birds within ±10% of the mean corresponds to a CV of roughly 8%. The lower the CV, the more uniform (and better developed) the flock.',
      cv_dialog_note: 'Reference bands based on widely published broiler management guides (e.g. Aviagen Ross Broiler Management Handbook; Cobb Broiler Management Guide). Adjust to your integration\'s standard.',
      sort_by: 'Sort by',
      sort_name: 'Name',
      sort_uniformity: 'Uniformity',
      sort_deviation: 'Deviation',
      sort_age: 'Age',
      average_weight_indicator: 'Average weight',
      gain_indicator: 'Weight gain',
      max_min_indicator: 'Max / Min',
      min_max_indicator: 'Min / Max',
      reference_deviation_indicator: 'Vs. reference',
      reference_target: 'Target {0}',
      weight_uniformity: 'Average weight uniformity',
      uniformity_by_age: 'Uniformity by age',
      weight_sd_chart: 'Average weight and standard deviation',
      weight_distribution: 'Weight distribution (last day)',
      total_birds: 'Total birds: {0}',
      projected_tag: '(Proj.)',
      export: 'Export',
      export_csv: 'Export data (.csv)',
      export_pdf: 'Export as PDF',
      range_very_light: 'Very light',
      range_light: 'Light',
      range_ideal: 'Ideal',
      range_heavy: 'Heavy',
      range_very_heavy: 'Very heavy',
      daily_weight_gain: 'Daily weight gain',
      average_weight_chart: 'Average weight',
      weight_projection: 'Weight projection',
      inform_projection_period: 'Inform the projection period',
      projection_flock_finished: 'Flock finished — projection is only available for in-progress flocks',
      projection_available_from_age_25: 'Projection is available from age 25.',
      date: 'Date',
      days: 'Days',
      project: 'Project',
      projected_weight: 'Projected weight: {0}g',
      projected_weight_standard: 'Projected (avg. gain): {0}g',
      projected_weight_genetics: 'Projected (strain): {0}g',
      inform_projection_days: 'Inform the number of days (maximum 5).',
      inform_projection_date: 'Inform the projection date (maximum 5 days).',
      invalid_days: 'The number of days must be between 1 and 5.',
      invalid_date: 'The date must be 1 to 5 days from today.',
      weights_table: 'Weights table',
      projection: 'Projection',
      projection_standard: 'Projection (avg. gain)',
      projection_genetics: 'Projection (strain)',
      grams: 'g',
      sex: 'Sex',
      genetics: 'Genetics (strain)',
      sex_as_hatched: 'As-hatched (mixed)',
      sex_male: 'Male',
      sex_female: 'Female',
      sex_mixed: 'Mixed sexed',
      target_curve: 'Reference curve',
      target_weight: 'Target weight',
      reference_curve_hint: 'No strain set on the flock; showing Cobb 500 (the most common in Brazil) as reference.',
      reference_curve_official: 'Reference curve: {0} — official breeder performance objectives.',
      view_source: 'View reference source',
      view_source_short: 'View source',
      view_source_page: 'View source (p. {0})',
      deviation_vs_target: 'vs. target',
      deviation_above: '{0}% above standard',
      deviation_below: '{0}% below standard',
      deviation_on_target: 'On the strain standard',
      projection_follows_curve: 'The genetics projection scales the breed curve to the current flock weight, keeping the flock ratio to the breed standard (it does not assume the flock starts gaining at the breed rate); the average-gain projection uses the recent daily gain.',
      based_on_n_weighings: 'Based on {0} weighings',
      low_sample_warning: 'Few weighings — low-confidence indicator.',
      performance_indices: 'Performance indices',
      feed_conversion: 'Feed conversion (FCR)',
      epef: 'EPEF',
      live_birds: 'Live birds',
      feed_consumed: 'Feed consumed',
      water_consumption: 'Water consumption',
      feed_intake_per_bird: 'Feed per bird',
      intake_per_day_reference: '{0}/day',
      daily_intake_today: 'Today so far: {0}/bird',
      daily_intake_none: 'No consumption recorded yet today, or no silo measurement equipment installed.',
      daily_intake_unsupported: 'Daily consumption is not reported by the SMAAI 5 controller.',
      viability: 'Viability',
      locked_feature: 'Feature unavailable',
      fcr_requires_silo: 'Feed conversion and EPEF require silo measurement. Add an Inobram silo scale to unlock these indicators.',
      water_requires_meter: 'Water consumption requires a connected water meter. Talk to Inobram to enable water monitoring.',
      water_feed_ratio: 'Water:feed {0}',
      water_feed_ratio_target: 'target 1.6–2.0',
      water_feed_ratio_measuring: 'measuring',
      unlock_hint: 'Requirements to unlock this feature:',
      what_is_this: 'What is this?',
      info_average_weight: 'Average bird weight at the latest weighing of the day, computed by the scale from the birds that stepped on the platform. It is the basis for the other indicators and for the projection.',
      info_gain: 'Daily weight gain: the difference between the current average weight and the average weight of the previous weighing. Shows the flock growth pace. Compared to the strain expected daily gain at the flock age (green at target or within 5% below, amber down to 15% below, red beyond).',
      info_feed_intake_per_bird: 'Feed per bird — compared to the strain cumulative reference for the flock age (silo feed ÷ live birds). Deviations in either direction are worth attention: below may signal a drop in appetite (health); above signals waste or silo miscalibration. Green within ±7%, amber within ±15%, red beyond. Requires silo measurement. Today intake is shown for reference only (it builds up during the day and resets at age change) and is not reported by the SMAAI 5 controller.',
      info_max_min: 'Highest and lowest average weight recorded over the analysed period, useful to observe the range and variation of the flock over time.',
      info_reference_deviation: 'How far the current average weight is above (+) or below (−) the weight expected by the strain genetics curve for the current age. Green: up to 3%; amber: 3% to 7%; red: above 7%. When the flock has no genetics set, the default Cobb 500 curve is used.',
      info_live_birds: 'Estimated live birds in the flock: birds housed minus the accumulated mortality (natural + culling) recorded in the mortality entries.',
      info_viability: 'Percentage of birds still alive relative to the total housed (live birds ÷ housed birds). The higher it is, the lower the loss to mortality.',
      info_feed_conversion: 'Feed conversion ratio (FCR): kilograms of feed consumed per kilogram of live weight produced (feed ÷ total live weight). Requires silo measurement to obtain the feed consumed. Compared to the expected FCR for the strain at the flock age (green within +3%, amber +3–7%, red beyond; below target is better). When no reference exists for the age, fixed bands apply: ≤ 1.60 good · 1.60–1.75 average · > 1.75 poor.',
      info_epef: 'European Production Efficiency Factor: (viability % × live weight kg) ÷ (age × FCR) × 100. Summarises performance, gain and survival in a single number. Depends on feed conversion (silo measurement). Reference: ≥ 350 good · 300–350 average · < 300 poor (400+ excellent).',
      info_water_consumption: 'Total volume of water consumed by the flock, in liters. Requires a connected water meter to be measured. On SMAAI 5 SMART/PRO controllers, the day water:feed ratio (liters per kg) is compared to the reference band 1.6–2.0 (green), 1.4–2.3 (amber), outside that red. It varies with temperature (rises in heat); low may mean birds under-drinking, high indicates heat stress, gut issues or a leak. The SMAAI 5 does not report daily feed, so the ratio is not shown.'
    },
    account_deletion: {
      title: 'Delete your Inobram account',
      intro: 'This page explains how to delete your account for the Inobram App and the Inobram Platform, developed by Inobram. Both use the same account, so deleting it ends your access to both. You do not need the app installed.',
      how_to_request: 'How to delete your account',
      step_sign_in: 'Click "Sign in to delete my account" and sign in with your account\'s email and password.',
      step_confirm: 'Read the warnings, tick both confirmations and enter your password again.',
      step_delete: 'Click "Delete account". The account and the data listed below are deleted right away.',
      sign_in_to_delete: 'Sign in to delete my account',
      cannot_sign_in: 'Cannot sign in? Email',
      cannot_sign_in_details: 'from the address registered on the account, with the subject "Account deletion". We will confirm the deletion by email within 15 days.',
      email_subject: 'Account deletion',
      what_is_deleted: 'What is deleted',
      deleted_account: 'Your account: sign-in email, name, phone number and password.',
      deleted_owned_properties: 'The properties, nuclei and houses you are the Owner of, with their flocks, mortality entries and silos. Other users lose access to them.',
      deleted_owned_devices: 'The devices you are the Owner of, their registration details and subscriptions.',
      deleted_shared_access: 'Your access to properties and devices shared with you.',
      deleted_settings: 'Your notification settings, your devices\' notification registrations and your sessions.',
      what_is_kept: 'What is kept',
      kept_device_readings: 'Readings and alarms recorded by the controllers belong to the equipment, not to your account, and are no longer linked to you.',
      kept_legal_records: 'Tax and billing records, if any, are kept for the period required by law.',
      signed_in_as: 'You are signed in as',
      warning: 'Deletion is permanent and cannot be undone. You will lose access to the Inobram App and the Inobram Platform. The properties and devices you are the Owner of will be deleted, and every user will lose access to them.',
      understand_loss: 'I understand that I will lose access to all Inobram digital products',
      want_delete: 'Yes, I want to delete this Inobram account and all the data in it',
      current_password: 'Current password',
      delete_account: 'Delete account',
      error_wrong_password: 'Wrong password.',
      error_too_many_attempts: 'Too many attempts. Wait a few minutes and try again.',
      error_deleting: 'Your account could not be deleted. Try again or email {email}.',
      deleted_title: 'Account deleted',
      deleted_message: 'Your Inobram account and the data linked to it have been deleted.'
    }
  },
  es_ES: {
    message: {
      batch_number_is_required: 'Se requiere el número de lote',
      device_is_required: 'Se requiere dispositivo',
      barn_is_required: 'Se requiere cobertizo',
      initial_date_is_required: 'Se requiere la fecha inicial',
      initial_hour_is_required: 'Se requiere la hora inicial',
      final_date_is_required: 'Se requiere la fecha final',
      final_hour_is_required: 'Se requiere la hora final',
      state_is_required: 'Se requiere estado',
      quantity_housed_is_required: 'Se requiere la cantidad alojada',
      quantity_housed_must_be_an_integer: 'La cantidad alojada debe ser un número entero',
      quantity_housed_must_be_greater_than_or_equal_to_zero: 'La cantidad alojada debe ser mayor o igual a cero',
      quantity_housed_must_be_less_than_or_equal_to_1000000: 'La cantidad alojada debe ser menor o igual a 1000000',
      loading: 'Cargando...',
      curtain: 'Cortina',
      water_temperature: 'Temperatura de agua',
      external_temperature: 'Temperatura externa',
      external_humidity: 'Humedad externa',
      external_temp: 'Temp. externa',
      external_humid: 'Humed. externa',
      water_temp: 'Temp. agua',
      curtain_opening_percentage: 'Porcentaje de apertura da la cortina',
      line: 'Lineal',
      bar: 'Barra',
      area: 'Zona',
      opened: 'Abierto',
      closed: 'Cerrado',
      batch_number: 'Número de lote',
      finished: 'Terminado',
      in_progress: 'En proceso',
      running: 'Ejecutándose ',
      from: 'del',
      confirming_action_cannot_undone: 'Al confirmar, esta acción no se podrá deshacer.',
      status: 'Estado',
      side: 'Lado',
      wind: 'Viento',
      weight_percentage_heavy: 'Pesado',
      weight_percentage_light: 'Leve',
      weight_percentage_very_heavy: 'Muy pesado',
      weight_percentage_very_light: 'Muy leve',
      weight_distribution: 'Distribución de peso',
      weight_percentage: 'Porcentaje de peso',
      daily_weight_gain: 'Aumento diario de peso',
      weight_gain: 'Aumento de peso',
      average_weight: 'Peso promedio',
      maximum_weight: 'Peso máximo',
      minimum_weight: 'Peso minimo',
      maximum_and_minium_weights: 'Pesos máximos e mínimos',
      maximum_and_minimum_temperatures: 'Temperaturas máximas y mínimas',
      maximum_and_minimum_humidities: 'Humedades máximas y mínimas',
      maximum_and_minimum_co2: 'CO2 máximas y mínimas',
      chart: 'Gráfico',
      charts: 'Gráficos',
      correlations: 'Correlaciones',
      environment: 'Ambiente',
      performance: 'Rendimiento',
      email_must_be_valid: 'El Email debe ser válido',
      internet_connection: 'Conexión a Internet',
      latitude: 'Latitud',
      longitude: 'Longitud',
      responsible_contact: 'Contacto responsable',
      responsible_phone: 'Teléfono responsable',
      responsible_email: 'Email responsable',
      owner: 'Dueño',
      birth_day: 'Fecha de nacimiento',
      change: 'Alterar',
      account: 'Cuenta',
      entries: 'Entradas',
      width: 'Anchura',
      height: 'Altura',
      length: 'Longitud',
      date: 'Fecha',
      initial_date: 'Fecha inicial',
      final_date: 'Fecha final',
      initial_hour: 'Hora inicial',
      final_hour: 'Hora final',
      reading: 'Lectura',
      readings: 'Lecturas',
      statistic: 'Estadística',
      statistics: 'Estadísticas',
      inobram_platform: 'Plataforma Inobram',
      platform: 'Plataforma',
      enter: 'Entrar',
      forgot_my_password: 'He olvidado mi contraseña',
      access_demo: 'Acceder a la demostración',
      recover_password: 'Recuperar contraseña',
      recover_password_in_app_instructions: 'Para recuperar su contraseña, utilice la opción "He olvidado mi contraseña" en la aplicación Inobram. Ingrese el correo electrónico o teléfono registrado, reciba el código de verificación y defina una nueva contraseña.',
      add: 'Añadir',
      add_device: 'Añadir dispositivo',
      list_devices: 'Listar dispositivos',
      device: 'Dispositivo',
      devices: 'Dispositivos',
      equipment: 'Equipo',
      equipments: 'Equipos',
      type: 'Especie',
      description: 'Descripción',
      indicates_that_the_field_is_required: '*Indica que el campo es obligatorio',
      create_your_account: 'Crea tu cuenta',
      create: 'Crear',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      save: 'Guardar',
      save_for_all: 'Guadar para todos',
      name: 'Nombre',
      password: 'Contraseña',
      confirm_the_password: 'Confirme la contraseña',
      password_must_be_at_least_6_characters: 'La contraseña debe tener al menos 6 caracteres',
      the_password_is_invalid_or_the_user_does_not_have_a_password: 'La contraseña no es válida o el usuario no tiene una contraseña.',
      the_email_address_is_badly_formatted: 'La dirección de correo electrónico está mal formateada.',
      there_is_no_user_record_corresponding_to_this_identifier_the_user_may_have_been_deleted: 'No hay registro de usuario correspondiente a este identificador. El usuario puede haber sido eliminado.',
      profile: 'Perfil',
      add_nucleus: 'Añadir núcleo',
      list_nuclei: 'Listar núcleos ',
      nuclei: 'Núcleos',
      nucleus: 'Núcleo',
      add_property: 'Añadir propiedad',
      edit_property: 'Editar propiedad',
      property: 'Propied',
      properties: 'Propiedades',
      users: 'Usuários',
      add_user: 'Añadir usuário',
      updated_at: 'Actualizado en',
      reports_and_settings: 'Informes y configuraciones',
      establishing_remote_access_session: 'Estableciendo sesión de acceso remoto',
      remote_access_failed: 'No se pudo establecer la sesión de acceso remoto. Verifique si el dispositivo está en línea.',
      only_owner_can_remote_access: 'Solo el propietario del dispositivo puede acceder remotamente al controlador',
      water_consumption_today: 'Consumo de agua hoy',
      water_consumption: 'Consumo de agua',
      daily_water_consumption: 'Consumo diario de agua',
      feed_level: 'Nível del pienso',
      yes: 'Si',
      no: 'No',
      alerts: 'Alertas',
      settings: 'Ajustes',
      not_connected: 'No conectado',
      inobram_account: 'Cuenta Inobram',
      navigation_menu: 'Menú de navegación',
      exit: 'Salida',
      added_at: 'Añadido a',
      added_by: 'Añadido por',
      edit: 'Editar',
      delete: 'Borrar',
      delete_mortality_from_date: 'Borrar mortalidad desde la fecha',
      close: 'Cerrar',
      all: 'Todos',
      rows_per_page: 'Líneas por página',
      no_data: 'Datos no disponibles',
      items_to_show: 'Elementos para mostrar',
      chage_view_mode: 'Cambia el modo de visualización',
      setting_alarm_value: 'Ajuste de valor de alarma',
      invalid_mac: 'MAC inválido',
      invalid_mac_pattern: 'Patrón de MAC no válido',
      to_view: 'Visualizar',
      minimum: 'Mínimo',
      maximum: 'Máximo',
      alarm_level: 'Nivel de alarma',
      next: 'Siguiente',
      previous: 'Anterior',
      countries: 'Países',
      states: 'Estados',
      cities: 'Ciudades',
      sexes: 'Sexos',
      country: 'País',
      state: 'Estado',
      city: 'Ciudad',
      sex: 'Sexo',
      device_models: 'Modelos de dispositivo',
      device_types: 'Tipos de dispositivo',
      mortalities: 'Mortalidades',
      device_model: 'Modelo de dispositivo',
      device_type: 'Tipo de dispositivo',
      mortality: 'Mortalidad',
      daily_mortality: 'Mortalidad diaria',
      culling_deaths: 'Muertes de rechazo',
      culling: 'Rechazo',
      natural_deaths: 'Muertes naturales',
      natural: 'Natural',
      quantity: 'Cantidad',
      quantity_housed: 'Cantidad alojada',
      batch: 'Lote',
      batches: 'Lotes',
      wall: 'Pared',
      walls: 'Paredes',
      floor: 'Piso',
      floors: 'Pisos',
      roof: 'Techo',
      roofs: 'Techos',
      inner_curtain: 'Cortina interior',
      inner_curtains: 'Cortinas interiores',
      outer_curtain: 'Cortina exterior',
      outer_curtains: 'Cortinas exteriores',
      lining: 'Forro',
      linings: 'Forros',
      evaporative_plate: 'Placa evaporativa',
      evaporative_plates: 'Placas evaporativas',
      lighting_system: 'Sistema de iluminación',
      lighting_systems: 'Sistemas de iluminación',
      internet_access_type: 'Tipo de acceso a Internet',
      internet_access_types: 'Tipos de acceso a Internet',
      barn: 'Cobertizo',
      barns: 'Cobertizos',
      filter_by_property: 'Filtrar por propiedad',
      filter_by_nucleus: 'Filtrar por núcleo',
      filter_by_country: 'Filtrar por país',
      filter_by_state: 'Filtrar por estado',
      filter_by_city: 'Filtrar por ciudad',
      location: 'Ubicación',
      structure: 'Estructura',
      filters: 'Filtros',
      view_mode: 'Modo de visualización',
      card_view: 'Tarjetas',
      list_view: 'Lista',
      active_filters: '{count} filtro activo | {count} filtros activos',
      clear_filters: 'Limpiar filtros',
      no_barns_found: 'No se encontraron cobertizos.',
      barn_type: 'Tipo de cobertizo',
      barn_types: 'Tipos de cobertizos',
      voltage_type: 'Tipo de tensión',
      voltage_types: 'Tipos de tesión',
      air_inlet: 'Entrada de aire',
      air_inlets: 'Entradas de aire',
      silo_type: 'Tipo de silo',
      silo_types: 'Tipos de silo',
      water_box: 'Caja de água',
      water_boxes: 'Cajas de água',
      watchdog_system: 'Sistema de vigilancia',
      watchdog_systems: 'Sistemas de vigilancia',
      batch_state: 'Estado del lote',
      batch_states: 'Estados del lote',
      capacity: 'Capacidad',
      capacity_estimated: 'estimada',
      manufacturer: 'Fabricante',
      manufacturers: 'Fabricantes',
      ok: 'OK',
      copied_to_the_clipboard: 'copiado al portapapeles.',
      error_copying_text: 'Error al copiar el texto.'
    },
    notification_history: {
      notifications: 'Notificaciones',
      unread_count: '{count} no leídas',
      mark_all_as_read: 'Marcar todas como leídas',
      no_notifications: 'Aún no tienes notificaciones',
      load_error: 'No se pudieron cargar las notificaciones',
      see_all: 'Todas las notificaciones',
      load_more: 'Cargar más',
      notified_at: 'Notificado a las {time}',
      viewed_at: 'Vista el {time}',
      delivery_sent: 'Entregada',
      delivery_failed: 'Error en la entrega',
      delivery_no_device: 'No enviada: ningún dispositivo conectado'
    },
    alarm: {
      alarm: 'Alarma',
      alarms: 'Alarmas',
      active_alarms: 'Alarmas Activas',
      alarms_and_notifications: 'Alarmas y Notificaciones',
      see_all: 'Ver Todas',
      mute: 'Silenciar',
      mute_all: 'Silenciar todas',
      unmute: 'Reactivar sonido',
      reactivate_all: 'Reactivar todas',
      alarm_history: 'Historial de Alarmas',
      tab_analysis: 'Análisis de Alarmas',
      no_active_alarms: 'No hay alarmas activas en este momento',
      no_alarm_history: 'No hay alarmas registradas en este período',
      select_barn_and_batch: 'Seleccione un cobertizo y un lote para ver el historial de alarmas',
      all_barns: 'Todos los Cobertizos',
      select_batch: 'Seleccione un Lote',
      sort_by: 'Ordenar por:',
      sort_date: 'Fecha',
      sort_name: 'Nombre',
      date_time: 'Fecha/Hora',
      alarms_per_page: 'Alarmas por página',
      current: 'Actual',
      updated_just_now: 'Actualizado ahora mismo',
      updated_seconds_ago: 'Actualizado hace {count}s',
      updated_minutes_ago: 'Actualizado hace {count} min',
      updated_at: 'Actualizado a las {time}',
      overview_last_24h: 'Vista general · Últimas 24h · Todos los cobertizos',
      new_alarm_flash: '¡Nueva alarma!',
      sound_enabled: 'Sonido activado',
      sound_disabled: 'Sonido bloqueado — haga clic para activar',
      sound_unavailable: 'Sonido no disponible en este navegador',
      alarms_silenced: 'Alarmas silenciadas',
      filters: 'Filtros',
      axis_date: 'Fecha',
      axis_age: 'Edad del Lote',
      start_date: 'Fecha inicial',
      start_time: 'Hora inicial',
      end_date: 'Fecha final',
      end_time: 'Hora final',
      age_start: 'Edad inicial',
      age_end: 'Edad final',
      info_last_days: 'Mostrando datos de los últimos 7 días. Seleccione un cobertizo y un lote para un análisis más detallado.',
      info_filtered: 'Mostrando datos del cobertizo y lote seleccionados.',
      clear_all_filters: 'Limpiar todos los filtros',
      export: 'Exportar',
      export_csv: 'Exportar CSV',
      export_pdf: 'Exportar PDF',
      report_title: 'Informe de Alarmas',
      report_generated_at: 'Generado el',
      report_period: 'Período',
      report_summary: 'Resumen',
      charts: 'Gráficos',
      total_alarms: 'Total de Alarmas',
      alarm_records: 'Registros de alarmas',
      alarm_peak: 'Pico de Alarmas',
      alarms_per_day: 'Alarmas p/día',
      alarms_label: 'alarmas',
      timeline_title: 'Línea de Tiempo de Alarmas',
      distribution_by_barn: 'Distribución de Alarmas por Cobertizo',
      distribution_title: 'Distribución de Alarmas',
      alarm_type: 'Tipo de Alarma',
      quantity: 'Cantidad',
      proportion: 'Proporción',
      total: 'Total',
      page: 'Página',
      heatmap_title: 'Mapa de Calor - Horarios Críticos',
      low_quantity: 'Baja Cantidad',
      high_quantity: 'Alta Cantidad',
      details_title: 'Detalles de Alarmas',
      details_inobramx_note: 'Las columnas de resolución y de valores ambientales deseados solo se completan para controladores SMAAI 5 PRO/SMART. Para los demás modelos, estos campos aparecen como “-”.',
      col_resolved_at: 'Resuelto en',
      col_alarm_value: 'Valor de la alarma',
      col_temp_desired: 'Temp. Deseada (°C)',
      col_temp_avg: 'Temp. Media (°C)',
      col_humidity_desired: 'Hum. Deseada (%)',
      col_humidity_avg: 'Hum. Media (%)',
      col_pressure_desired: 'Pres. Deseada (pa)',
      col_pressure_avg: 'Pres. Media (pa)',
      col_co2: 'CO2 (ppm)',
      high_temperature: 'Temperatura alta',
      low_temperature: 'Temperatura baja',
      high_humidity: 'Humedad alta',
      low_humidity: 'Humedad baja',
      high_pressure: 'Presion baja',
      low_pressure: 'Presion baja',
      low_battery: 'Bateria baja',
      low_source: 'Fuente sin energia',
      no_probe_installed: 'Sin sonda instalada',
      null_temperature: 'Leitura de sonda',
      probe_error: 'Error em sonda',
      relay_error: 'Error en la placa de rele',
      LEIT_SONDA: 'Error en la lectura de sonda',
      INST_SONDA: 'Error en la instalación de sonda',
      TEMP_ALTA: 'Temperatura alta',
      TEMP_BAIXA: 'Temperatura baja',
      UMIDADE_ALTA: 'Humedad alta',
      UMIDADE_BAIXA: 'Humedad baja',
      PRESSAO_ALTA: 'Presión alta',
      PRESSAO_BAIXA: 'Presión baja',
      BATERIA_BAIXA: 'Batería baja',
      FALTA_ENERGIA: 'Falta de energia',
      DESARME_CORT: 'Desarme de la cortina',
      ERROR_RELAY: 'Error en la placa de rele',
      ERROR_PROBE_TH2O1: 'Error en la sonda TH2O1',
      ERROR_PROBE_TH2O2: 'Error en la sonda TH2O2',
      ERROR_PROBE_TH2O3: 'Error en la sonda TH2O3',
      ERRO_SONDA_TH2O1: 'Error en la sonda TH2O1',
      ERRO_SONDA_TH2O2: 'Error en la sonda TH2O2',
      ERRO_SONDA_TH2O3: 'Error en la sonda TH2O3',
      ERRO_SONDA_T1: 'Error en la sonda T1',
      ERRO_SONDA_T2: 'Error en la sonda T2',
      ERRO_SONDA_T3: 'Error en la sonda T3',
      ERRO_SONDA_T4: 'Error en la sonda T4',
      ERRO_SONDA_T5: 'Error en la sonda T5',
      ERRO_SONDA_TU1: 'Error en la sonda TU1',
      ERRO_SONDA_TU2: 'Error en la sonda TU2',
      ERRO_SONDA_TU3: 'Error en la sonda TU3',
      ERRO_SONDA_U1: 'Error en la sonda U1',
      ERRO_SONDA_U2: 'Error en la sonda U2',
      ERRO_SONDA_P1: 'Error en la sonda P1',
      ERRO_SONDA_CO21: 'Error en la sonda CO21',
      ERRO_SONDA_H2O1: 'Error en la sonda H2O1',
      high_temp: 'Temperatura alta',
      low_temp: 'Temperatura baja',
      high_hum: 'Humedad alta',
      low_hum: 'Humedad baja',
      high_co2: 'CO2 alto',
      fault_energy: 'Falta de energia',
      low_bat: 'Batería baja',
      over_voltage: 'Sobretensión',
      ve_error: 'Error del sensor de viento',
      co2_error: 'Error en la sonda CO2',
      overload: 'Sobrecarga',
      t1_error: 'Error en la sondaT1',
      t2_error: 'Error en la sondaT2',
      t3_error: 'Error en la sondaT3',
      t4_error: 'Error en la sondaT4',
      th2o1_error: 'Error en la sondaTH2O1',
      th2o2_error: 'Error en la sondaTH2O2',
      th2o3_error: 'Error en la sondaTH2O3',
      tu1_error: 'Error en la sondaTU1',
      tu2_error: 'Error en la sondaTU2',
      tu3_error: 'Error en la sondaTU3',
      tu4_error: 'Error en la sondaTU4',
      u1_error: 'Error en la sondaU1',
      u2_error: 'Error en la sondaU2',
      ve1_error: 'Error en la sonda VE1'
    },
    notification: {
      attention: 'Atención',
      confirm_exclusion: 'Confirma la exclusíon?',
      deleted_successfully: 'Eliminado con éxito!',
      saved_successfully: 'Salvo con éxito!',
      there_was_an_error_saving: 'Hubo un error guardando',
      there_was_an_error: 'Hubo un error',
      discontinued_add_device_warning: 'Para agregar dispositivos, use la aplicación InoBram'
    },
    card_legend: {
      title: 'Entendiendo los indicadores de la tarjeta',
      intro: 'Cada medidor y barra cambia de color según el estado de su variable. Esta es la lógica de cada uno: Use el botón de configuración (engranaje) para elegir qué métricas aparecen en las tarjetas.',
      button: 'Leyenda de la tarjeta',
      state: {
        ideal: 'Ideal',
        attention: 'Atención',
        critical: 'Crítico',
        reference: 'Referencia',
        no_data: 'Sin datos'
      },
      temperature: {
        title: 'Temperatura',
        desc: 'El anillo muestra cuánto se aleja la temperatura actual de la temperatura deseada.',
        ideal: 'Hasta ±1 °C de la temperatura deseada.',
        attention: 'Entre ±1 °C y ±2 °C de la temperatura deseada.',
        critical: 'Más de ±2 °C de la temperatura deseada.',
        reference: 'Se muestra en azul cuando no hay temperatura deseada configurada.'
      },
      humidity: {
        title: 'Humedad',
        desc: 'El anillo se llena con la humedad relativa actual, coloreado por la distancia al objetivo.',
        ideal: 'Hasta ±5% de la humedad deseada.',
        attention: 'Entre ±5% y ±10% de la humedad deseada.',
        critical: 'Más de ±10% de la humedad deseada.',
        reference: 'Se muestra en azul cuando no hay humedad deseada configurada.'
      },
      co2: {
        title: 'CO₂',
        desc: 'El anillo se llena con la concentración de CO₂; la marca roja indica el límite elevado.',
        ideal: 'Hasta 1500 ppm (buena calidad del aire).',
        attention: 'Entre 1500 y 2500 ppm (calidad del aire moderada).',
        critical: 'Por encima de 2500 ppm (CO₂ elevado).',
        no_data: 'Se muestra en gris cuando no hay lectura disponible.'
      },
      feels_like: {
        title: 'Sensación térmica',
        desc: 'Temperatura que las aves realmente perciben, combinando calor y humedad. Se compara con la temperatura deseada.',
        equation: 'AT = T + 0.33 × e − 4.00\ne = (HR / 100) × 6.105 × exp(17.27 × T / (237.7 + T))',
        where: 'T = temperatura (°C); HR = humedad relativa (%); e = presión de vapor (hPa). Temperatura aparente de Steadman (interior, sin viento).',
        ideal: 'Sensación hasta ±1 °C de la temperatura deseada.',
        attention: 'Entre ±1 °C y ±2 °C de la temperatura deseada.',
        critical: 'Más de ±2 °C de la temperatura deseada.',
        reference: 'Se muestra en azul cuando no hay temperatura deseada configurada.'
      },
      thi: {
        title: 'THI (índice de temperatura y humedad)',
        desc: 'Indicador de estrés por calor que combina temperatura y humedad en un solo número.',
        equation: 'THI = T − (0.31 − 0.0031 × HR) × (T − 14.4)',
        where: 'T = temperatura (°C); HR = humedad relativa (%). Adaptado de NRC (1971) / Marai et al. (2001) para aves.',
        ideal: 'Por debajo de 27 (sin estrés por calor).',
        attention: 'Entre 27 y 29 (alerta de calor).',
        critical: 'Igual o por encima de 29 (estrés por calor).'
      },
      enthalpy: {
        title: 'Entalpía',
        desc: 'Energía total del aire (calor sensible + latente) que el ave debe disipar. Cuanto mayor, más difícil el intercambio de calor.',
        equation: 'h = 1.006 × T + W × (2501 + 1.805 × T)\nW = 0.622 × Pv / (Patm − Pv)',
        where: 'W = razón de mezcla (kg agua / kg aire seco); Pv = presión de vapor; Patm = 101,325 kPa. La banda ideal depende de la edad (Rodrigues et al. 2011).',
        reference: 'Valor informativo (azul): la banda ideal depende de la edad del lote.'
      },
      ventilation: {
        title: 'Ventilación',
        desc: 'Señal combinada de calidad del aire. CO₂ alto indica poca renovación de aire; junto con humedad elevada apunta a ventilación insuficiente (típico del frío, en ventilación mínima).',
        equation: 'CO₂ > 2500 ppm  ⇒  Mala\nCO₂ > 1500 ppm  o  HR alta  ⇒  Moderada',
        where: 'HR alta = 10% por encima del objetivo (o más de 70% sin objetivo). Combina CO₂ y humedad.',
        ideal: 'CO₂ y humedad bajo control (buena ventilación).',
        attention: 'CO₂ moderado o humedad elevada (ventilación moderada).',
        critical: 'CO₂ alto, a menudo con humedad elevada (ventilación mala).',
        no_data: 'Se muestra en gris cuando no hay lectura de CO₂.'
      },
      silo: {
        title: 'Silos',
        desc: 'Las barras se llenan con el nivel de pienso como porcentaje de la capacidad del silo (20.000 kg cuando no se configura ninguna capacidad).',
        ideal: 'Igual o por encima del 30% de la capacidad.',
        attention: 'Entre el 15% y el 30% de la capacidad.',
        critical: 'Por debajo del 15% de la capacidad.'
      },
      metrics: {
        title: 'Edad, presión, agua y peso',
        desc: 'Valores informativos, sin estados de color: edad del lote (días), presión estática (Pa), agua consumida hoy (L) y peso medio de las aves (g). La presión y el agua se pueden ocultar en la configuración de la tarjeta.'
      }
    },
    card_settings: {
      button: 'Configuración de la tarjeta',
      title: 'Métricas mostradas en las tarjetas',
      intro: 'Elija qué métricas opcionales aparecen en cada tarjeta de dispositivo.',
      reset: 'Restablecer',
      pressure: { title: 'Presión estática', desc: 'Presión estática de ventilación (Pa).' },
      water: { title: 'Agua', desc: 'Agua consumida hoy (L).' },
      feelsLike: { title: 'Sensación térmica', desc: 'Temperatura aparente que combina calor y humedad.' },
      thi: { title: 'THI', desc: 'Índice de temperatura y humedad (estrés por calor).' },
      enthalpy: { title: 'Entalpía', desc: 'Carga térmica total del aire (kJ/kg de aire seco).' },
      ventilation: { title: 'Ventilación', desc: 'Calidad del aire a partir de CO₂ y humedad.' }
    },
    comfort: {
      feels_like: 'Sensación',
      feels_like_tip: 'Temperatura aparente (sensación térmica): combina calor y humedad.',
      thi: 'THI',
      thi_tip: 'Índice de temperatura y humedad — indicador de estrés por calor.',
      enthalpy: 'Entalpía',
      enthalpy_tip: 'Entalpía del aire (kJ/kg de aire seco) — carga térmica total.',
      ventilation: 'Ventilación',
      ventilation_tip: 'Calidad de la ventilación a partir de CO₂ y humedad.',
      ventilation_good: 'Buena',
      ventilation_moderate: 'Moderada',
      ventilation_poor: 'Mala',
      ventilation_no_data: '--'
    },
    environment: {
      age: 'Edad',
      days: 'días',
      temperature: 'Temperatura',
      humidity: 'Humedad',
      pressure: 'Presion',
      co2: 'CO2',
      air_quality_good: 'Buena calidad del aire',
      air_quality_moderate: 'Calidad del aire moderada',
      air_quality_high: 'CO2 elevado',
      water: 'Agua',
      weight: 'Peso',
      desired_weight: 'Peso deseado',
      silo: 'Silo',
      silos: 'Silos',
      desired_temperature: 'Temperatura deseada',
      desired_temperature_prefix: 'Temp. deseada',
      maximum_temperature: 'Temperatura máxima',
      minimum_temperature: 'Temperatura mínima',
      desired_humidity: 'Humedad deseada',
      desired_humidity_prefix: 'Humed. deseada',
      maximum_humidity: 'Humedad máxima',
      minimum_humidity: 'Humedad mínima',
      desired_pressure: 'Presión deseada',
      desired_pressure_prefix: 'Pres. deseada',
      maximum_co2: 'CO2 máxima',
      minimum_co2: 'CO2 mínima',
      average_temperature: 'Temperatura promedio',
      average_temperature_internal: 'Temp. promedio interna',
      average_temperature_external: 'Temp. promedio externa',
      average_humidity: 'Humedad promedio',
      average_humidity_internal: 'Hum. promedio interna',
      average_humidity_external: 'Hum. promedio externa',
      average_co2: 'CO2 promedio',
      temperature_range: 'Rango de temperatura',
      temperature_range_internal: 'Rango temp. interna',
      humidity_range: 'Rango de humedad',
      humidity_range_internal: 'Rango humed. interna',
      co2_range: 'Rango de CO2',
      weight_range: 'Rango de peso',
      range_to: 'a',
      show_external: 'Mostrar externa',
      external_humidity_range: 'Rango humed. externa',
      external_temperature_range: 'Rango temp. externa',
      delta_temperature: 'Delta temperatura (int - ext)',
      delta_humidity: 'Delta humedad (int - ext)',
      delta_temperature_desired: 'Δ deseada - promedio',
      delta_humidity_desired: 'Δ deseada - promedio',
      weight_gain_vs_temp: 'Ganancia de peso vs desvío de temperatura',
      temp_deviation: 'Desvío de temperatura (°C)',
      mortality_vs_environment: 'Mortalidad vs temperatura/humedad',
      temp_deviation_short: 'Δ Temperatura',
      humidity_deviation_short: 'Δ Humedad',
      water_vs_temp: 'Consumo de agua vs temperatura',
      water_liters: 'Agua (l)',
      avg_temp: 'Temp. promedio (°C)',
      uniformity_vs_co2: 'Uniformidad de peso vs CO2',
      weight_cv: 'CV peso (%)',
      avg_co2: 'CO2 promedio (ppm)',
      water_per_bird_vs_gain: 'Agua por ave vs ganancia de peso',
      water_per_bird: 'Agua/ave (ml)',
      weight_gain_vs_humidity: 'Ganancia de peso vs desvío de humedad',
      humidity_deviation: 'Desvío de humedad (%)',
      quantity_housed: 'Cantidad alojada'
    },
    prefix: {
      ag: 'Ed',
      dt: 'Td',
      at: 'T',
      dh: 'Hd',
      ah: 'H',
      wt: 'Ag (L)',
      dw: 'Pd (g)',
      aw: 'Pm (g)',
      dp: 'Pd (Pa)',
      ap: 'P (Pa)',
      s1: 'S1',
      s2: 'S2',
      st: 'Estado',
      t_max: 'T max',
      t_min: 'T min',
      h_max: 'H max',
      h_min: 'H min',
      p_max: 'P max',
      p_min: 'P min',
      co2_max: 'co2 max',
      co2_min: 'co2 min',
      h2o_acc: 'h2o acumulado'
    },
    table: {
      of: 'de',
      all: 'Todos',
      rows_per_page_text: 'Líneas por página',
      quantity_per_page_text: 'Cantidad por página'
    },
    banner_premium_plan: {
      platform: 'Plataforma',
      info: '\nPara más detalles sobre la disponibilidad de esta función, por favor contacta con nuestro equipo a través del siguiente contacto:\n',
      get_in_touch: 'Entrar en\ncontacto'
    },
    insights: {
      title: 'Insights del lote',
      no_insights: 'Sin observaciones para este lote',
      heat_stress: '{count} día(s) con estrés térmico detectado',
      heat_stress_detail: 'Temperatura promedio por encima del setpoint en más de 2°C en las edades: {ages}',
      co2_breach: '{count} día(s) con CO₂ por encima de 2500 ppm',
      co2_breach_detail: 'La concentración elevada puede causar estrés respiratorio. Edades: {ages}',
      humidity_out_of_range: '{count} día(s) con humedad fuera del rango ideal',
      humidity_detail: 'Desviación promedio por encima del 10% del setpoint en las edades: {ages}',
      uniformity_alert: '{count} día(s) con baja uniformidad de peso (CV > 10%)',
      uniformity_detail: 'Peor día: edad {age} con CV de {cv}%',
      growth_decline: 'Caída pronunciada en la ganancia de peso',
      growth_decline_detail: 'Pico de {peakGain}g/día en la edad {peakAge}, cayó a {currentGain}g/día',
      peak_growth: 'Pico de ganancia diaria: {gain}g en la edad {age}',
      water_gain_spike: '{count} día(s) con relación agua/ganancia por encima de lo normal',
      water_gain_spike_detail: 'Consumo elevado relativo a la ganancia en las edades: {ages}',
      mortality_spike: '{count} día(s) con mortalidad por encima del promedio',
      mortality_spike_detail: 'Picos en las edades: {ages} (promedio del lote: {avg}/día)',
      total_mortality: 'Mortalidad acumulada de {pct}% del lote',
      info_title: 'Cómo funcionan los insights',
      info_intro: 'La plataforma analiza automáticamente los datos del lote y genera observaciones cuando identifica condiciones que pueden impactar el rendimiento. A continuación se muestran todos los análisis que el sistema puede realizar:',
      info_heat_stress_title: 'Estrés térmico',
      info_heat_stress_desc: 'Compara la temperatura promedio interna (promedio entre máxima y mínima del día) con el setpoint de temperatura configurado. Señala cuando el promedio supera el setpoint en más de 2°C. Se vuelve crítico cuando 3 o más días presentan esta condición.',
      info_co2_title: 'CO₂ elevado',
      info_co2_desc: 'Monitorea la concentración máxima diaria de CO₂. Señala cuando el pico supera 2500 ppm, nivel que puede causar estrés respiratorio en las aves. Se vuelve crítico con 3 o más días por encima del límite.',
      info_humidity_title: 'Humedad fuera de rango',
      info_humidity_desc: 'Calcula la desviación de la humedad promedio interna respecto al setpoint configurado. Señala cuando la desviación absoluta supera 10 puntos porcentuales. Se vuelve advertencia con 5 o más días fuera de rango.',
      info_uniformity_title: 'Uniformidad de peso',
      info_uniformity_desc: 'Calcula el coeficiente de variación (CV% = desviación estándar / peso promedio × 100) a partir de los datos de pesaje diarios, sin considerar la primera semana de vida (la variación de peso en el alojamiento es natural). Señala cuando el CV supera 10%, indicando que el lote puede estar desuniforme.',
      info_growth_title: 'Caída en la ganancia de peso',
      info_growth_desc: 'Identifica el pico de ganancia diaria de peso y señala si la ganancia actual cayó por debajo del 60% de ese pico dentro de los últimos 5 días, lo que puede indicar problemas de salud o nutricionales. También informa el día del pico de ganancia como referencia.',
      info_peak_growth_title: 'Pico de ganancia diaria',
      info_peak_growth_desc: 'Informa la edad y el valor de la mayor ganancia diaria de peso registrada en el lote, sirviendo como referencia para evaluar la curva de crecimiento.',
      info_water_gain_title: 'Relación agua/ganancia',
      info_water_gain_desc: 'Calcula la relación entre consumo de agua y ganancia de peso diaria y la compara con la propia tendencia reciente del lote (promedio de los días anteriores), sin considerar la primera semana de vida. Señala cuando la relación sube de forma abrupta (más de 1,35× la tendencia reciente) durante al menos 2 días, lo que puede indicar problemas de salud o confort térmico.',
      info_mortality_title: 'Mortalidad',
      info_mortality_desc: 'Monitorea la mortalidad diaria, sin considerar la primera semana de vida (la mortalidad de alojamiento es naturalmente más alta). Señala cuando un día registra más del doble del promedio del período siguiente (crítico por encima del triple). También monitorea la mortalidad acumulada: advertencia por encima del 3% y crítico por encima del 5% del total alojado.',
      info_severity_title: 'Niveles de severidad:',
      info_severity_critical: 'Crítico — requiere atención inmediata',
      info_severity_warning: 'Advertencia — merece seguimiento',
      info_severity_info: 'Informativo — dato de referencia'
    },
    chart_dialog: {
      mortality_dialog: 'Este gráfico muestra la mortalidad para cada edad del lote, diferenciando entre las mortalidades por descarte y las ocurridas por causas naturales.',
      water_consumption_dialog: 'Este gráfico muestra el consumo de agua para cada edad del lote.',
      weight_distribution_dialog: 'Este gráfico muestra la distribución de peso en niveles porcentuales para cada sonda en cada edad del lote.',
      weight_gain_dialog: 'Este gráfico muestra la ganancia de peso para cada edad.',
      average_weight_dialog: 'Este gráfico muestra el peso promedio para cada edad, así como el peso más alto y más bajo registrado para esa edad.',
      co2_dialog: 'Este gráfico muestra el CO2 promedio para cada edad, así como el promedio más alto y más bajo de CO2 registrado para esa edad.',
      humidity_dialog: 'Este gráfico muestra la humedad promedio para cada edad, así como el promedio más alto y más bajo de humedad registrado para esa edad.',
      temperature_dialog: 'Este gráfico muestra la temperatura promedio para cada edad, así como el promedio más alto y más bajo de temperatura registrado para esa edad.',
      mortality_dialog_title: 'Gráfico de mortalidad',
      water_consumption_dialog_title: 'Gráfico de consumo diario de agua',
      weight_distribution_dialog_title: 'Gráfico de distribución de peso',
      weight_gain_dialog_title: 'Gráfico de ganancia de peso diaria',
      average_weight_dialog_title: 'Gráfico de peso promedio',
      co2_dialog_title: 'Gráfico de CO2',
      humidity_dialog_title: 'Gráfico de humedad',
      temperature_dialog_title: 'Gráfico de temperatura',
      weight_gain_vs_temp_dialog: 'Correlaciona la ganancia de peso diaria con el desvío de la temperatura promedio respecto al setpoint. Permite identificar cómo el estrés térmico afecta el rendimiento.',
      weight_gain_vs_temp_dialog_title: 'Ganancia de peso vs desvío de temperatura',
      mortality_vs_env_dialog: 'Superpone la mortalidad diaria con los desvíos de temperatura y humedad respecto a los setpoints. Ayuda a identificar causas ambientales de mortalidad.',
      mortality_vs_env_dialog_title: 'Mortalidad vs ambiente',
      water_vs_temp_dialog: 'Correlaciona el consumo de agua con la temperatura promedio interna. Las aves consumen más agua a temperaturas elevadas — desvíos del patrón pueden indicar problemas.',
      water_vs_temp_dialog_title: 'Consumo de agua vs temperatura',
      uniformity_vs_co2_dialog: 'Correlaciona el coeficiente de variación del peso (uniformidad) con el CO2 promedio. Niveles elevados de CO2 pueden reducir la uniformidad del lote.',
      uniformity_vs_co2_dialog_title: 'Uniformidad vs CO2',
      water_per_bird_vs_gain_dialog: 'Muestra la relación entre consumo de agua por ave y ganancia de peso. Una proporción creciente puede indicar estrés, enfermedad o problemas de alimentación.',
      water_per_bird_vs_gain_dialog_title: 'Agua por ave vs ganancia de peso',
      weight_gain_vs_humidity_dialog: 'Correlaciona la ganancia de peso con el desvío de humedad respecto al setpoint. La humedad alta reduce la capacidad de termorregulación de las aves.',
      weight_gain_vs_humidity_dialog_title: 'Ganancia de peso vs desvío de humedad'
    },
    aei: {
      dashboard: 'Panel',
      filter_by_complex: 'Filtrar por complejo',
      filter_by_site: 'Filtrar por sitio',
      no_filter_match: 'Ningún galpón coincide con los filtros.',
      house_count: '1 galpón | {count} galpones',
      machine_count: '1 equipo | {count} equipos',
      kpi: {
        feed: 'Alimento',
        temperature: 'Temperatura',
        humidity: 'Humedad',
        co2: 'CO₂',
        nh3: 'NH₃',
        water: 'Agua',
        outside_temp: 'Temp. exterior',
        static_pressure: 'Presión',
        cooler_temp: 'Cámara fría',
        ph: 'pH',
        water_temp: 'Temp. del agua',
        flow_efficiency: 'Eficiencia de flujo',
        run_time_efficiency: 'Tiempo productivo',
        total_cases: 'Cajas',
        stops: 'Paradas',
        concentration: 'Sanitizante',
        recirculation_temp: 'Temp. recirculación',
        water_flow: 'Caudal de agua',
        ph_target: 'pH objetivo',
        run_time: 'Tiempo de operación',
        sanitizer_flow: 'Caudal de sanitizante',
        undiluted_concentration: 'Sanitizante puro'
      },
      feed_bins: 'Silos de alimento',
      houses: 'Galpones',
      processing: 'Sala de procesamiento',
      title: 'AEI Integra',
      total_feed: 'Alimento total',
      bin: 'Silo',
      no_houses: 'Ningún galpón ha reportado datos todavía.',
      no_readings: 'Sin lecturas disponibles.',
      no_processing: 'Ningún equipo de procesamiento ha reportado datos todavía.',
      stale: 'Desactualizado',
      stale_hint: 'La última lectura tiene más de 12 horas.',
      measured_at: 'Medido en',
      updated_just_now: 'Actualizado ahora mismo',
      updated_minutes: 'Actualizado hace {count} min',
      updated_hours: 'Actualizado hace 1 hora | Actualizado hace {count} horas',
      updated_days: 'Actualizado hace 1 día | Actualizado hace {count} días',
      gateway_seen_just_now: 'Último envío ahora mismo',
      gateway_seen_minutes: 'Último envío hace {count} min',
      gateway_seen_hours: 'Último envío hace 1 hora | Último envío hace {count} horas',
      gateway_seen_days: 'Último envío hace 1 día | Último envío hace {count} días',
      gateway_never_seen: 'Aún no se recibió ningún envío',
      last_reading: 'Última lectura',
      loading: 'Cargando...',
      records: {
        feed_bin: 'Silos de alimento',
        environment: 'Ambiente',
        water_use: 'Consumo de agua',
        feed_use: 'Consumo de alimento',
        feed_delivered: 'Entregas de alimento',
        alarm: 'Alarmas',
        chicken: 'Lote',
        flock: 'Alojamiento',
        egg: 'Conteo de huevos',
        tier_egg: 'Recolección de huevos',
        fan: 'Ventiladores',
        heater: 'Calefactores',
        cool_cell: 'Paneles evaporativos y bombas',
        vfd_fan: 'Velocidad de ventilación',
        light: 'Iluminación',
        power: 'Salidas',
        sensor: 'Sensores de temperatura',
        group: 'Zonas de temperatura',
        maintenance: 'Mantenimiento'
      },
      back_to_houses: 'Galpones',
      metric: 'Variable',
      value: 'Valor',
      plan_inactive: 'El plan AEI de este complejo no está activo. Ya no se reciben datos; el historial sigue disponible.',
      devices_without_plan: 'Ningún dispositivo sin plan activo. | 1 dispositivo sin plan activo ya no recibe datos. | {count} dispositivos sin plan activo ya no reciben datos.'
    },
    bird_weight: {
      title: 'Pesajes',
      subtitle: 'Pesaje de aves',
      all_barns: 'Todos los galpones',
      select_barn: 'Galpón',
      select_batch: 'Seleccione el lote',
      tab_history: 'Historial de pesaje',
      tab_analysis: 'Análisis y proyección de peso',
      back_to_overview: 'Pesajes',
      no_barn_selected: 'Seleccione un galpón para ver el historial de pesaje y el análisis de peso.',
      no_weighings: 'No hay pesajes disponibles.',
      no_batch_selected: 'Seleccione un lote para ver los pesajes.',
      loading: 'Cargando...',
      age: 'Edad',
      average_weight: 'Peso promedio',
      weighing_gain: 'Ganancia de peso',
      weight_count: 'Cantidad de pesaje',
      max: 'Peso máximo',
      min: 'Peso mínimo',
      standard_deviation: 'Desviación estándar',
      ideal_weight: 'Peso ideal',
      uniformity: 'Uniformidad',
      current_weight: 'Peso actual: {0}g',
      overview_current_age: 'Edad actual',
      overview_last_weighing: 'Último pesaje',
      overview_uniformity: 'Uniformidad',
      overview_deviation: 'Desviación vs. curva',
      overview_no_data: 'Sin pesajes',
      overview_no_data_hint: 'Este galpón aún no tiene pesajes registrados.',
      overview_open_batch: 'Sin lote abierto',
      overview_status_running: 'En curso',
      overview_status_closed: 'Cerrado',
      overview_view_history: 'Historial y Proyección',
      overview_weighing_age: 'Edad {0}',
      overview_days: 'días',
      overview_flock: 'Lote',
      tabs_disabled_hint: 'Seleccione un galpón para habilitar',
      dashboard_heading: 'Visión general de pesajes',
      dashboard_overview_badge: 'Todos los galpones',
      dashboard_flocks_in_weighing: 'Lotes en pesaje',
      dashboard_avg_uniformity: 'Uniformidad media',
      dashboard_avg_deviation: 'Desviación media vs. curva',
      dashboard_best_flock: 'Mejor desempeño',
      dashboard_least_uniform_flock: 'Lote menos uniforme',
      dashboard_underperforming_flock: 'Lote por debajo de la curva',
      dashboard_uniformity_hint: 'Uniformidad = coeficiente de variación (CV); menor es mejor.',
      dashboard_deviation_hint: 'Desviación = peso medio vs. peso esperado de la línea a la misma edad; por encima de la curva es mejor.',
      deviation_dialog_title: 'Desviación vs. curva de referencia',
      deviation_dialog_intro: 'Compara el peso medio del lote con el peso esperado de la línea a la misma edad.',
      deviation_dialog_relevance: 'Como considera la edad y la genética de cada lote, permite comparar lotes de diferentes edades de forma justa.',
      deviation_dialog_note: 'Por encima de la curva (verde) es bueno; por debajo (rojo) requiere atención.',
      deviation_band_on_or_above: 'En el estándar o por encima',
      deviation_band_below: 'Por debajo del estándar',
      deviation_band_well_below: 'Muy por debajo del estándar',
      kpi_info_flocks_in_weighing: 'Número de lotes a los que tienes acceso que actualmente tienen al menos un pesaje registrado.',
      kpi_info_avg_deviation: 'Promedio de la desviación del peso promedio de cada lote respecto al peso esperado por la curva de referencia de la línea a la edad actual del lote (desviación% = (peso promedio − peso de la curva) ÷ peso de la curva). Como se normaliza por edad y genética, lotes de diferentes edades se comparan de forma justa. Positivo = peso promedio por encima del estándar (bueno); negativo = por debajo. Verde = en el estándar o por encima, ámbar = por debajo, rojo = muy por debajo.',
      kpi_info_best_flock: 'El lote cuyo peso promedio está más POR ENCIMA del peso esperado por su curva de referencia de la línea para su edad. El desempeño se mide por esa desviación del peso promedio respecto a la curva (no por el peso absoluto). Estar por encima de la curva es bueno (más pesado que el estándar de la línea para su edad), por eso se muestra en verde, no en rojo.',
      kpi_info_underperforming_flock: 'El lote cuyo peso promedio está más POR DEBAJO del peso esperado por su curva de referencia de la línea para su edad — el que más necesita atención. El desempeño se mide por la desviación del peso promedio respecto a la curva. Por debajo del estándar se muestra en ámbar (moderadamente por debajo) o rojo (muy por debajo).',
      uniformity_excellent: 'Excelente',
      uniformity_good: 'Buena',
      uniformity_fair: 'Aceptable',
      uniformity_poor: 'Mala',
      cv_dialog_title: 'Uniformidad del lote (CV)',
      cv_dialog_intro: 'La uniformidad se mide por el coeficiente de variación (CV) del peso de las aves: la desviación estándar dividida por el peso medio, en porcentaje. Al ser una razón, permite comparar lotes de diferentes edades.',
      cv_eq_sd: 'desviación estándar',
      cv_eq_mean: 'peso medio',
      cv_dialog_relevance: 'Por qué importa: un CV bajo indica un lote homogéneo, que tiende a tener mejor conversión alimenticia, faena más previsible y mejor bienestar. Como referencia, alrededor del 80% de las aves dentro de ±10% de la media equivale a un CV de aproximadamente 8%. Cuanto menor sea el CV, más uniforme (y mejor desarrollado) está el lote.',
      cv_dialog_note: 'Rangos de referencia basados en guías de manejo de pollos de engorde ampliamente difundidas (p. ej. Aviagen Ross Broiler Management Handbook; Cobb Broiler Management Guide). Ajústelos al estándar de su integración.',
      sort_by: 'Ordenar por',
      sort_name: 'Nombre',
      sort_uniformity: 'Uniformidad',
      sort_deviation: 'Desviación',
      sort_age: 'Edad',
      indicators: 'Indicadores',
      average_weight_indicator: 'Peso promedio',
      gain_indicator: 'Ganancia de peso',
      max_min_indicator: 'Máx / Mín',
      min_max_indicator: 'Mín / Máx',
      reference_deviation_indicator: 'Vs. referencia',
      reference_target: 'Objetivo {0}',
      weight_uniformity: 'Uniformidad de peso promedio',
      uniformity_by_age: 'Uniformidad por edad',
      weight_sd_chart: 'Peso promedio y desviación estándar',
      weight_distribution: 'Distribución de pesos (último día)',
      total_birds: 'Total de aves: {0}',
      projected_tag: '(Proy.)',
      export: 'Exportar',
      export_csv: 'Exportar datos (.csv)',
      export_pdf: 'Exportar como PDF',
      range_very_light: 'Muy liviano',
      range_light: 'Liviano',
      range_ideal: 'Ideal',
      range_heavy: 'Pesado',
      range_very_heavy: 'Muy pesado',
      daily_weight_gain: 'Ganancia de peso diaria',
      average_weight_chart: 'Peso promedio',
      weight_projection: 'Proyección de peso',
      inform_projection_period: 'Informe el período de proyección',
      projection_flock_finished: 'Lote finalizado — la proyección solo está disponible para lotes en curso',
      projection_available_from_age_25: 'La proyección está disponible a partir de la edad 25.',
      date: 'Fecha',
      days: 'Días',
      project: 'Proyectar',
      projected_weight: 'Peso proyectado: {0}g',
      projected_weight_standard: 'Proyectado (ganancia media): {0}g',
      projected_weight_genetics: 'Proyectado (línea): {0}g',
      inform_projection_days: 'Informe el número de días (máximo 5).',
      inform_projection_date: 'Informe la fecha de proyección (máximo 5 días).',
      invalid_days: 'El número de días debe estar entre 1 y 5.',
      invalid_date: 'La fecha debe ser de 1 a 5 días a partir de hoy.',
      weights_table: 'Tabla de pesos',
      projection: 'Proyección',
      projection_standard: 'Proyección (ganancia media)',
      projection_genetics: 'Proyección (línea)',
      grams: 'g',
      sex: 'Sexo',
      genetics: 'Genética (línea)',
      sex_as_hatched: 'Mixto (macho y hembra)',
      sex_male: 'Macho',
      sex_female: 'Hembra',
      sex_mixed: 'Sexado mixto',
      target_curve: 'Curva de referencia',
      target_weight: 'Peso objetivo',
      reference_curve_hint: 'Sin línea informada en el lote; mostrando Cobb 500 (la más común en Brasil) como referencia.',
      reference_curve_official: 'Curva de referencia: {0} — objetivos oficiales de desempeño de la línea.',
      view_source: 'Ver fuente de referencia',
      view_source_short: 'Ver fuente',
      view_source_page: 'Ver fuente (pág. {0})',
      deviation_vs_target: 'vs. objetivo',
      deviation_above: '{0}% sobre el estándar',
      deviation_below: '{0}% bajo el estándar',
      deviation_on_target: 'En el estándar de la línea',
      projection_follows_curve: 'La proyección por línea escala la curva al peso actual del lote, manteniendo su proporción actual respecto al estándar (no asume que el lote pase a ganar al ritmo genético); la proyección por ganancia media usa la ganancia diaria reciente.',
      based_on_n_weighings: 'Basado en {0} pesajes',
      low_sample_warning: 'Pocos pesajes — indicador de baja confiabilidad.',
      performance_indices: 'Índices de desempeño',
      feed_conversion: 'Conversión alimenticia (CA)',
      epef: 'IEP',
      live_birds: 'Aves vivas',
      feed_consumed: 'Ración consumida',
      water_consumption: 'Consumo de agua',
      feed_intake_per_bird: 'Ración por ave',
      intake_per_day_reference: '{0}/día',
      daily_intake_today: 'Hoy hasta ahora: {0}/ave',
      daily_intake_none: 'Sin consumo registrado hoy todavía, o sin balanza de silo instalada.',
      daily_intake_unsupported: 'El consumo diario no es informado por el controlador SMAAI 5.',
      viability: 'Viabilidad',
      locked_feature: 'Recurso no disponible',
      fcr_requires_silo: 'La conversión alimenticia y el IEP requieren medición de silo. Instale una balanza de silo Inobram para desbloquear estos indicadores.',
      water_requires_meter: 'El consumo de agua requiere un medidor de agua conectado. Hable con Inobram para habilitar el monitoreo de agua.',
      water_feed_ratio: 'Agua/ración {0}',
      water_feed_ratio_target: 'objetivo 1,6–2,0',
      water_feed_ratio_measuring: 'midiendo',
      unlock_hint: 'Requisitos para desbloquear este recurso:',
      what_is_this: '¿Qué es esto?',
      info_average_weight: 'Peso promedio de las aves en la última pesada del día, calculado por la balanza a partir de las aves que pasaron por la plataforma. Es la base para los demás indicadores y para la proyección.',
      info_gain: 'Ganancia de peso del día: diferencia entre el peso promedio actual y el peso promedio de la pesada anterior. Indica el ritmo de crecimiento del lote. Comparada con la ganancia diaria esperada de la línea a la edad del lote (verde en el objetivo o hasta 5% por debajo, ámbar hasta 15% por debajo, rojo más allá).',
      info_feed_intake_per_bird: 'Ración por ave — comparada con la referencia acumulada de la línea para la edad del lote (ración del silo ÷ aves vivas). Los desvíos en cualquier dirección merecen atención: por debajo puede indicar caída de apetito (salud); por encima, desperdicio o descalibración del silo. Verde hasta ±7%, ámbar hasta ±15%, rojo más allá. Requiere medición de silo. El consumo del día se muestra solo como referencia (se acumula durante el día y se reinicia al cambio de edad) y no es informado por el controlador SMAAI 5.',
      info_max_min: 'Mayor y menor peso promedio registrado en el período analizado, útiles para observar la amplitud y la variación del lote a lo largo del tiempo.',
      info_reference_deviation: 'Cuánto está el peso promedio actual por encima (+) o por debajo (−) del peso esperado por la curva genética de la línea para la edad actual. Verde: hasta 3%; ámbar: 3% a 7%; rojo: por encima de 7%. Cuando el lote no tiene genética definida, se usa la curva estándar Cobb 500.',
      info_live_birds: 'Estimación de aves vivas en el lote: aves alojadas menos la mortalidad acumulada (natural + descarte) registrada en los ingresos de mortalidad.',
      info_viability: 'Porcentaje de aves que permanecen vivas respecto al total alojado (aves vivas ÷ aves alojadas). Cuanto mayor, menor la pérdida por mortalidad.',
      info_feed_conversion: 'Conversión alimenticia (CA): kilos de alimento consumidos por kilo de peso vivo producido (alimento ÷ peso vivo total). Requiere medición de silo para calcular el alimento consumido. Comparada con la CA esperada de la línea a la edad del lote (verde hasta +3%, ámbar +3–7%, rojo por encima; por debajo del objetivo es mejor). Sin referencia para la edad, se usan bandas fijas: ≤ 1,60 buena · 1,60–1,75 media · > 1,75 mala.',
      info_epef: 'Índice de Eficiencia Productiva: (viabilidad % × peso vivo kg) ÷ (edad × CA) × 100. Resume desempeño, ganancia y supervivencia en un solo número. Depende de la conversión alimenticia (medición de silo). Referencia: ≥ 350 bueno · 300–350 medio · < 300 malo (400+ excelente).',
      info_water_consumption: 'Volumen total de agua consumido por el lote, en litros. Requiere un medidor de agua conectado para ser medido. En controladores SMAAI 5 SMART/PRO, la relación agua/ración del día (litros por kg) se compara con la banda de referencia 1,6–2,0 (verde), 1,4–2,3 (ámbar), fuera de eso rojo. Varía con la temperatura (sube con el calor); por debajo puede indicar aves que beben poco, por encima indica estrés térmico, problema intestinal o una fuga. El SMAAI 5 no informa la ración diaria, por lo que la relación no se muestra.'
    },
    account_deletion: {
      title: 'Eliminar su cuenta Inobram',
      intro: 'Esta página explica cómo eliminar su cuenta de Inobram App y de la Plataforma Inobram, desarrollados por Inobram. Ambos usan la misma cuenta, por lo que eliminarla termina el acceso a los dos. No necesita tener la aplicación instalada.',
      how_to_request: 'Cómo eliminar su cuenta',
      step_sign_in: 'Haga clic en "Entrar para eliminar mi cuenta" e ingrese con el correo y la contraseña de su cuenta.',
      step_confirm: 'Lea los avisos, marque las dos confirmaciones e ingrese su contraseña nuevamente.',
      step_delete: 'Haga clic en "Eliminar cuenta". La cuenta y los datos listados abajo se eliminan en el momento.',
      sign_in_to_delete: 'Entrar para eliminar mi cuenta',
      cannot_sign_in: '¿No puede entrar? Envíe un correo a',
      cannot_sign_in_details: 'desde la dirección registrada en la cuenta, con el asunto "Eliminación de cuenta". Confirmaremos la eliminación por correo en un plazo de 15 días.',
      email_subject: 'Eliminación de cuenta',
      what_is_deleted: 'Qué se elimina',
      deleted_account: 'Su cuenta: correo de acceso, nombre, teléfono y contraseña.',
      deleted_owned_properties: 'Las propiedades, núcleos y galpones de los que usted es Propietario, con sus lotes, registros de mortalidad y silos. Los demás usuarios pierden el acceso a ellos.',
      deleted_owned_devices: 'Los equipos de los que usted es Propietario, sus datos de registro y suscripciones.',
      deleted_shared_access: 'Su acceso a propiedades y equipos compartidos con usted.',
      deleted_settings: 'Su configuración de notificaciones, los registros de sus dispositivos para notificaciones y sus sesiones.',
      what_is_kept: 'Qué se conserva',
      kept_device_readings: 'Las lecturas y alarmas registradas por los controladores pertenecen al equipo, no a su cuenta, y dejan de estar vinculadas a usted.',
      kept_legal_records: 'Los registros fiscales y de facturación, si los hay, se conservan durante el plazo exigido por la ley.',
      signed_in_as: 'Ha iniciado sesión como',
      warning: 'La eliminación es definitiva y no se puede deshacer. Perderá el acceso a Inobram App y a la Plataforma Inobram. Las propiedades y los equipos de los que usted es Propietario se eliminarán, y todos los usuarios perderán el acceso a ellos.',
      understand_loss: 'Entiendo que perderé el acceso a todos los productos digitales de Inobram',
      want_delete: 'Sí, quiero eliminar esta cuenta Inobram y todos los datos que contiene',
      current_password: 'Contraseña actual',
      delete_account: 'Eliminar cuenta',
      error_wrong_password: 'Contraseña incorrecta.',
      error_too_many_attempts: 'Demasiados intentos. Espere unos minutos e inténtelo de nuevo.',
      error_deleting: 'No fue posible eliminar su cuenta. Inténtelo de nuevo o envíe un correo a {email}.',
      deleted_title: 'Cuenta eliminada',
      deleted_message: 'Su cuenta Inobram y los datos vinculados a ella han sido eliminados.'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/index.js